"use client"

import React, { useEffect, useState, useMemo } from "react"
import { Link } from "react-router-dom"
import ContentHeader from "../../components/ContentHeader"
import Loader from "../../components/Loader"
import axios from "axios"
import Swal from "sweetalert2"
import $ from "jquery"
import "datatables.net-bs4"
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css"
import "select2"
import "select2/dist/css/select2.min.css"
import { Tooltip } from "bootstrap"
import DatePicker, { registerLocale } from "react-datepicker"
import es from "date-fns/locale/es"
import "react-datepicker/dist/react-datepicker.css"
import "./seat-selection.css"

// Register Spanish locale for DatePicker
registerLocale("es", es)

const ListTickets = () => {
  const [title, setTitle] = useState("")
  const [date, setDate] = useState(new Date())
  const [search, setSearch] = useState([])
  const [branchs, setBranchs] = useState([])
  const [type, setType] = useState(0)
  const [loading, setLoading] = useState(false)
  const [tickets, setTickets] = useState([])
  const [origins, setOrigins] = useState([])
  const [schedule, setSchedule] = useState([])
  const [destinations, setDestinations] = useState([])
  const [schedulesDisponibles, setSchedulesDisponibles] = useState([])
  const [ticket_id, setTicketId] = useState(0)
  const [name, setName] = useState("")
  const [last_name, setLastName] = useState("")
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [date_ticket, setDateTicket] = useState("")
  const [time_ticket, setTimeTicket] = useState("")
  const [seat, setSeat] = useState(0)
  const [status, setStatus] = useState(0)
  const [state, setState] = useState(0)
  const [schedule_id, setScheduleId] = useState(0)
  const [user_id, setUserId] = useState(0)
  const [price, setPrice] = useState("")
  const [date_sale, setDateSale] = useState("")
  const [time_sale, setTimeSale] = useState("")
  const [purchase_order, setPurChaseOrder] = useState("")
  const [origin_id, setOriginId] = useState(0)
  const [destination_id, setDestinationId] = useState(0)
  const [courtesy, setCourtesy] = useState(0)
  const [sale, setSale] = useState("")
  const [number_ticket, setNumberTicket] = useState("")
  const [time_received, setTimeReceived] = useState("")
  const [invoice, setInvoice] = useState(0)
  const [where_up, setWhereUp] = useState("")
  // 1 = Sí, 2 = No (start default as No so radios behave predictably)
  const [card_payment, setCardPayment] = useState(2)
  const [cardPaymentTransfer, setCardPaymentTransfer] = useState(2)
  const [dateCreated, setDateCreated] = useState("")
  const [card_status, setCardStatus] = useState("")
  const [ticket_office, setTicketOffice] = useState(0)
  const [transfer, setTransfer] = useState("")
  const [buys, setBuys] = useState(0)
  const [rol, setRol] = useState(0)
  const [reserved, setReserved] = useState(0)
  const [canceled, setCanceled] = useState(0)
  const [pending, setPending] = useState(0)
  const [collapseFilters, setcollapseFilters] = useState(true)
  const [origin_filter, setOriginFilter] = useState(0)
  const [destination_filter, setDestinationFilter] = useState(0)
  const [status_filter, setStatusFilter] = useState(0)
  const [type_filter, setTypeFilter] = useState(0)
  const [payment_filter, setPaymentFilter] = useState(0)
  const [user_filter, setUserFilter] = useState(0)
  const [users, setUsers] = useState([])
  const [rol_id, setRolId] = useState(0)
  const [date_filter, setDateFilter] = useState("")

  const [startDateFilter, setStartDateFilter] = useState("")
  const [endDateFilter, setEndDateFilter] = useState("")

  const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT
  const TITLEALERT = process.env.REACT_APP_TITLE_ALERT

  const [priceExtra, setPriceExtra] = useState(0)
  const [pricePet, setPricePet] = useState(0)
  const [basePrice, setBasePrice] = useState(0)
  const [totalAmount, setTotalAmount] = useState(0)
  const [cancelNote, setCancelNote] = useState("")
  const [date_cancel, setDateCancel] = useState("")
  const [user_cancel, setUserCancel] = useState("")
  const [box_office, setBoxOffice] = useState("")
  const [user_edit, setUserEdit] = useState("")
  const [date_updated, setDateUpdated] = useState("")



  const [sumUser13, setSumUser13] = useState(0);


const [dateFilterType, setDateFilterType] = useState('date_ticket'); 

  // Transfer states
  const [transferTicketId, setTransferTicketId] = useState(0)
  const [transferInvoice, setTransferInvoice] = useState("")
  const [availableSchedules, setAvailableSchedules] = useState([])
  const [selectedScheduleId, setSelectedScheduleId] = useState(0)
  const [availableSeats, setAvailableSeats] = useState([])
  const [selectedSeat, setSelectedSeat] = useState(0)
  const [busLayout, setBusLayout] = useState({})
  const [busCapacity, setBusCapacity] = useState(0)
  const [transferDate, setTransferDate] = useState(new Date())
  const [seatData, setSeatData] = useState([])
  const [transferOrigin, setTransferOrigin] = useState("")
  const [transferDestination, setTransferDestination] = useState("")
  const [selecionarHorario, setSelecionarHorario] = useState(false)
  const [filtradoBuscar, setFiltradoBuscar] = useState(false)
  const [daysBack, setDaysBack] = useState(25); 
  const [paymentMethod, setPaymentMethod] = useState(0); // 0: no seleccionado, 1: efectivo, 2: tarjeta, 3: transferencia
  const [transferNumber, setTransferNumber] = useState("");
  const [updatedNote, setUpdatedNote] = useState("")
  const [transferInfo, setTransferInfo] = useState("")
  const [transferApprovedBy, setTransferApprovedBy] = useState("")
  const [editApprovedBy, setEditApprovedBy] = useState("")
  const [transferRequiresApproval, setTransferRequiresApproval] = useState(false)
  const [transferRequests, setTransferRequests] = useState([])
  const [editRequests, setEditRequests] = useState([])
  const [originalEditValues, setOriginalEditValues] = useState({})

  const handleSearch = async (e) => {
    e.preventDefault()
    const user = JSON.parse(localStorage.getItem("dataUser"))
    const userRole = user.rol_id
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, "0")
    const day = date.getDate().toString().padStart(2, "0")
    const dateFormat = year + "-" + month + "-" + day
    const branchId = $("#branch_id").val()
    const originId = $("#origin_id").val()
    const destinationId = $("#destination_id").val()
    const form = new FormData()
    form.append("branch_id", branchId)
    form.append("origin_id", originId)
    form.append("destination_id", destinationId)
    form.append("date", dateFormat)
    form.append("type", "admin")
    form.append("user_role", userRole)
    
    // Limpiar el lado derecho
    setSelecionarHorario(false)
    setSelectedScheduleId(null)
    setSeatData([])
    setAvailableSeats([])
    
    setLoading(true)
    await axios
      .post(ENDPOINT + "search-trip", form)
      .then((response) => {
        setSearch(response.data.data)
        setFiltradoBuscar(true)
        setSchedulesDisponibles(response.data.data)
        
        // Limpiar selección de asientos
        setSelectedSeat(0)
        
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
        Swal.fire({
          icon: "error",
          title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
          showConfirmButton: true,
          timer: 3000,
          html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
          showClass: { popup: "animate__animated animate__fadeInDown" },
          hideClass: { popup: "animate__animated animate__fadeOutUp" },
        })
      })
  }


  const handleWhatsApp = async (invoice, name, last_name, phone) => {
    Swal.fire({
      title: "¿Enviar boleto por WhatsApp?",
      html: `
        <div>
          <strong>Folio:</strong> ${invoice}<br/>
          <strong>Pasajero:</strong> ${name} ${last_name}<br/>
          <strong>Teléfono:</strong> ${phone}
        </div>
        <small class="text-muted d-block mt-2">¿Está seguro que desea enviar este boleto por WhatsApp?</small>
      `,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, enviar",
      cancelButtonText: "No, cancelar",
      confirmButtonColor: "#198754",
      cancelButtonColor: "#c71c22",
      showClass: { popup: "animate__animated animate__fadeInDown" },
      hideClass: { popup: "animate__animated animate__fadeOutUp" },
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true)
        const user = JSON.parse(localStorage.getItem("dataUser"))
        const user_id = user.user_id
        const form = new FormData()
        form.append("invoice", invoice)
        form.append("user_id", user_id)
        try {
          await axios.post(ENDPOINT + "print-image-ticket-invoice", form, { responseType: "blob" })
          setLoading(false)
          Swal.fire({
            icon: "success",
            title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
            showConfirmButton: false,
            timer: 3000,
            html: '<div class="text-custom-alert">Boleto enviado por WhatsApp</div>',
            showClass: { popup: "animate__animated animate__fadeInDown" },
            hideClass: { popup: "animate__animated animate__fadeOutUp" },
          })
        } catch (error) {
          setLoading(false)
          Swal.fire({
            icon: "error",
            title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
            showConfirmButton: true,
            html: '<div class="text-custom-alert">Error al enviar por WhatsApp: ' + error.response.data.msg + "</div>",
            showClass: { popup: "animate__animated animate__fadeInDown" },
            hideClass: { popup: "animate__animated animate__fadeOutUp" },
          })
        }
      }
    })
  }


  const getAllUsers = async () => {
    setLoading(true)
    try {
      const response = await axios.get(ENDPOINT + "get-all-users")
      const usersArray = response.data.data.map(user => ({
        label: user.name,
        value: user.user_id
      }))
      setUsers(usersArray)
    } catch (error) {
      console.error("Error fetching users:", error)
    }
    setLoading(false)
  }

  const getAllBranchs = async () => {
    setLoading(true)
    const response = await axios.get(ENDPOINT + "get-all-branchs-ticket")
    const branchsArray = response.data.data.map((element) => ({
      label: element.name,
      value: element.branch_id,
    }))
    setBranchs(branchsArray)
    setLoading(false)
  }
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("dataUser"))
    setRolId(user.rol_id)
    getAll()
    getAllOrigins()
    getAllDestinations(0)
    getAllBranchs()
    getAllUsers()
    getTransferRequests()
    getEditRequests()
    setTimeout(() => {
      initializeSelect2()
      initializeSelect2Detail()
    }, 100)
    // Initialize tooltips
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    tooltipTriggerList.map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl))
  }, [])

  const initializeSelect2 = () => {
    $("#origin_id").select2({ width: "100%", dropdownParent: $("#modal-edit") }).on("change", (e) => {
      const value = e.target.value;
      setOriginId(value)
      getAllDestinations(value)
    });    
    $("#destination_id").select2({ width: "100%", dropdownParent: $("#modal-edit") }).on("change", (e) => {
      setDestinationId(e.target.value);
    }); 
    $("#payment_filter").on("change", (e) => {
      setPaymentFilter(e.target.value)
    });   
    $("#user_filter").on("change", (e) => {
      setUserFilter(e.target.value)
    })
    $("#status").select2({ width: "100%", dropdownParent: $("#modal-edit") })

    $("#status_filter").select2({ width: "100%" })
    $("#type_filter").select2({ width: "100%" })
    $("#origin_filter").select2({ width: "100%" })
    $("#destination_filter").select2({ width: "100%" })
  }

  const initializeSelect2Detail = () => {
    $("#origin_id_detail").select2({ width: "100%", dropdownParent: $("#modal-detail") })
    $("#destination_id_detail").select2({ width: "100%", dropdownParent: $("#modal-detail") })
    $("#status_detail").select2({ width: "100%", dropdownParent: $("#modal-detail") })
  }

  const initializeSelect2Transfer = () => {
    $("#transfer_schedule")
      .select2({
        width: "100%",
        dropdownParent: $("#modal-transfer"),
      })
      .on("select2:select", (e) => {
        const scheduleId = Number.parseInt(e.target.value)
        setSelectedScheduleId(scheduleId)
        getAvailableSeats(scheduleId)
      })
  }

  $("#status").on("change", (e) => {
    setStatus(e.target.value)
  })

  $("#type_filter").on("change", (e) => {
    setTypeFilter(e.target.value)
  })

  $("#origin_filter").on("change", (e) => {
    setOriginFilter(e.target.value)
  })

  $("#destination_filter").on("change", (e) => {
    setDestinationFilter(e.target.value)
  })

  $("#status_filter").on("change", (e) => {
    setStatusFilter(e.target.value)
  })

  const status_trip = [
    { label: "Comprado", value: 1 },
    { label: "Reservado", value: 2 },
    { label: "Cancelado", value: 3 },
    { label: "Pendiente de Pago", value: 4 },
  ]

  const payment_filter_options = [
    { label: "Todos", value: 0 },
    { label: "Efectivo", value: 1 },
    { label: "Transferencia", value: 2 },
    { label: "Tarjeta", value: 3 }
  ]

  // Mostrar solo Comprado si rol_id es 3; mostrar todos en caso contrario
  let filteredStatusTrip
  if (rol_id === 3) {
    filteredStatusTrip = status_trip.filter((item) => item.value === 1) // Solo muestra 'Comprado'
  } else {
    filteredStatusTrip = status_trip
  }

  const type_filter_search = [
    { label: "Taquilla", value: 1 },
    { label: "En línea", value: 2 },
  ]

  const handleCollapse = () => {
    setcollapseFilters(!collapseFilters)
  }

  const handleTransferSubmit = async (e) => {
    e.preventDefault()

    if (!selectedSeat) {
      Swal.fire({
        icon: "error",
        title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
        html: '<div class="text-custom-alert">Debe seleccionar un asiento para transferir el boleto</div>',
        showClass: { popup: "animate__animated animate__fadeInDown" },
        hideClass: { popup: "animate__animated animate__fadeOutUp" },
      })
      return
    }

    setLoading(true)
    const user = JSON.parse(localStorage.getItem("dataUser"))
    const user_id = user.user_id

    // Format date for API
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, "0")
    const day = date.getDate().toString().padStart(2, "0")
    const formattedDate = `${year}-${month}-${day}`
    const branchId = $("#branch_id").val()
    const originId = $("#origin_ida").val()
    const destinationId = $("#destination_ida").val()
    const selectedSchedule = schedulesDisponibles.find(
      (schedule) => Number(schedule.schedule_id) === Number(selectedScheduleId),
    )
    const newTime = selectedSchedule?.time || time_ticket

    try {
      const endpoint = transferRequiresApproval
        ? "ticket-transfer-requests"
        : "transfer-ticket"
      await axios.post(ENDPOINT + endpoint, {
        ticket_id: transferTicketId,
        new_schedule_id: selectedScheduleId, // Use selected schedule or original
        new_seat: selectedSeat,
        new_date: formattedDate,
        new_time: newTime,
        user_id: user_id,
        branch_id: branchId,
        origin_id: originId,
        destination_id: destinationId,
      })

      // Refresh ticket list and wait for completion
      await getAll()

      // Close the modal only after list refresh finishes
      $("#closemodal-transfer").trigger("click")

      Swal.fire({
        icon: "success",
        title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
        showConfirmButton: false,
        timer: 3000,
        html: `<div class="text-custom-alert">${transferRequiresApproval
          ? "Solicitud enviada y pendiente de aprobación"
          : "Boleto transferido exitosamente"}</div>`,
        showClass: { popup: "animate__animated animate__fadeInDown" },
        hideClass: { popup: "animate__animated animate__fadeOutUp" },
      })

      // Limpiar los campos después de una transferencia exitosa
      setSelectedSeat(0)
      setSelectedScheduleId(null)
      setSelecionarHorario(false)
    } catch (error) {
      // Limpiar los campos en caso de error
      setSelectedSeat(0)
      setSelectedScheduleId(null)
      setSelecionarHorario(false)

      Swal.fire({
        icon: "error",
        title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
        showConfirmButton: true,
        html:
          '<div class="text-custom-alert">' + (error.response?.data?.msg || "Error al transferir el boleto") + "</div>",
        showClass: { popup: "animate__animated animate__fadeInDown" },
        hideClass: { popup: "animate__animated animate__fadeOutUp" },
      })
    } finally {
      setLoading(false)
    }
  }

  // Función para obtener asientos disponibles
  const getAvailableSeats = async (scheduleId, date) => {
    setLoading(true)

    // Formatear fecha para la API
    let formattedDate
    if (date instanceof Date) {
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, "0")
      const day = date.getDate().toString().padStart(2, "0")
      formattedDate = `${year}-${month}-${day}`
    } else {
      formattedDate = date || formatDateForAPI(transferDate)
    }

    try {
      // Prepare requests in parallel to speed up the transfer workflow
      const seatForm = new FormData()
      seatForm.append("schedule_id", scheduleId || schedule_id)
      seatForm.append("date", formattedDate)

      const user = JSON.parse(localStorage.getItem("dataUser"))
      const userRole = user.rol_id
      const searchForm = new FormData()
      searchForm.append("branch_id", $("#branch_id").val())
      searchForm.append("origin_id", $("#origin_id").val())
      searchForm.append("destination_id", $("#destination_id").val())
      searchForm.append("date", formattedDate)
      searchForm.append("type", "admin")
      searchForm.append("user_role", userRole)

      const [seatResponse, schedulesResponse] = await Promise.all([
        axios.post(ENDPOINT + "get-all-booking-seats", seatForm),
        axios.post(ENDPOINT + "search-trip", searchForm),
      ])

      // Almacenar los datos completos de los asientos incluyendo el estado
      const seatData = seatResponse.data.data || []
      setSeatData(seatData)

      // Establecer asientos disponibles (status === 0)
      const availableSeats = seatData.filter((seat) => seat.status === 0).map((seat) => seat.seat)
      setAvailableSeats(availableSeats)

      // Buscar el horario específico para obtener su capacidad
      const selectedSchedule = schedulesResponse.data.data.find((s) => s.schedule_id == scheduleId)
      const capacity = selectedSchedule ? selectedSchedule.available : 11
      setBusCapacity(capacity)

      // Establecer el diseño del autobús según la capacidad
      if (capacity === 11) {
        setBusLayout({
          row1: [0, 0, 0, 0, 1],
          row2: [2, 3, 0, 0, 0],
          row3: [4, 5, 0, 0, 0],
          row4: [7, 8, 0, 0, 6],
          row5: [10, 11, 0, 0, 9],
        })
      } else if (capacity === 18) {
        setBusLayout({
          row1: [0, 0, 0, 18, 1],
          row2: [2, 3, 0, 17, 0],
          row3: [4, 5, 0, 0, 6],
          row4: [7, 8, 0, 0, 9],
          row5: [15, 16, 0, 0, 14],
          row6: [10, 11, 0, 12, 13],
        })
      } else {
        // Valor por defecto: 20 asientos
        setBusLayout({
          row1: [0, 0, 0, 20, 1],
          row2: [2, 3, 0, 0, 0],
          row3: [4, 5, 0, 0, 6],
          row4: [7, 8, 0, 0, 9],
          row5: [15, 16, 0, 0, 17],
          row6: [18, 19, 0, 0, 14],
          row7: [10, 11, 0, 12, 13],
        })
      }
    } catch (error) {
      console.error("Error fetching seats:", error)
      setAvailableSeats([])
      setSeatData([])
    } finally {
      setLoading(false)
    }
  }

  const [assigned_user, setAssignedUser] = useState(0)
  // Función para manejar la selección de asientos
  const handleSeatSelection = (seatNumber) => {
    // Check if seat is available
    const seatInfo = seatData.find((seat) => seat.seat === seatNumber)
    if (seatInfo && seatInfo.status !== 0) return

    setSelectedSeat(seatNumber === selectedSeat ? 0 : seatNumber)
  }

  // Función para abrir el modal de transferencia
  const handleTransfer = async (id) => {
    setLoading(true)
    try {
      // Limpiar los campos primero
      setSelectedSeat(0)
      setSelectedScheduleId(null)
      setSelecionarHorario(false)
      setSchedulesDisponibles([])
      setBusCapacity(null)
      setSeatData([])
      setAvailableSeats([])
      setTransferDate(new Date())
      setFiltradoBuscar(false)
      setTransferRequiresApproval(rol_id === 3)

      const response = await axios.get(ENDPOINT + "get-ticket/" + id)

      // Set transfer ticket details
      setTransferTicketId(response.data.data.ticket_id)
      setTransferInvoice(response.data.data.invoice)
      setName(response.data.data.name)
      setLastName(response.data.data.last_name)
      setOriginId(response.data.data.origin_id)
      setDestinationId(response.data.data.destination_id)
      setSeat(response.data.data.seat)
      setScheduleId(response.data.data.schedule_id)
      setDateTicket(response.data.data.date_ticket)
      setTimeTicket(response.data.data.time_ticket)
      setTotalAmount(Number.parseFloat(response.data.data.total_amount))
      setTransferOrigin(
        origins.find((o) => o.value === response.data.data.origin_id)?.label || ""
      )
      setTransferDestination(
        destinations.find((d) => d.value === response.data.data.destination_id)?.label || ""
      )
      
      // Reinicializar select2 para asegurar que se muestren los valores correctos
      setTimeout(() => {
        if ($('#transfer_schedule').length) {
          $('#transfer_schedule').select2({
            width: "100%",
            dropdownParent: $("#modal-transfer"),
          });
        }
      }, 100);

      // Set selected schedule to the original schedule
      setSelectedScheduleId(response.data.data.schedule_id)

      // Get available seats for the selected date and schedule
      await getAvailableSeats(response.data.data.schedule_id, formatDateForAPI(new Date()))

      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
      Swal.fire({
        icon: "error",
        title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
        showConfirmButton: true,
        html: '<div class="text-custom-alert">Error al cargar los datos del boleto</div>',
        showClass: { popup: "animate__animated animate__fadeInDown" },
        hideClass: { popup: "animate__animated animate__fadeOutUp" },
      })
    }
  }

  const getTransferRequests = async () => {
    const user = JSON.parse(localStorage.getItem("dataUser"))
    if (user?.rol_id !== 1) return
    try {
      const response = await axios.get(ENDPOINT + "ticket-transfer-requests", {
        params: { user_id: user.user_id },
      })
      setTransferRequests(response.data.data || [])
    } catch (error) {
      console.error("Error fetching transfer requests:", error)
    }
  }

  const reviewTransferRequest = async (requestId, action) => {
    const user = JSON.parse(localStorage.getItem("dataUser"))
    let reviewNote = ""

    if (action === "reject") {
      const result = await Swal.fire({
        title: "Motivo del rechazo",
        input: "textarea",
        inputPlaceholder: "Escriba el motivo del rechazo",
        showCancelButton: true,
        confirmButtonText: "Rechazar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#c71c22",
      })
      if (!result.isConfirmed || !result.value?.trim()) return
      reviewNote = result.value.trim()
    }

    try {
      setLoading(true)
      await axios.post(
        `${ENDPOINT}ticket-transfer-requests/${requestId}/${action}`,
        { user_id: user.user_id, review_note: reviewNote },
      )
      await getTransferRequests()
      await getAll()
      Swal.fire({
        icon: "success",
        title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
        text: action === "approve" ? "Transferencia aprobada" : "Solicitud rechazada",
        timer: 2500,
        showConfirmButton: false,
      })
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
        text: error.response?.data?.msg || "No fue posible revisar la solicitud",
      })
    } finally {
      setLoading(false)
    }
  }

  const getEditRequests = async () => {
    const user = JSON.parse(localStorage.getItem("dataUser"))
    if (user?.rol_id !== 1) return
    try {
      const response = await axios.get(ENDPOINT + "ticket-edit-requests", {
        params: { user_id: user.user_id },
      })
      setEditRequests(response.data.data || [])
    } catch (error) {
      console.error("Error fetching edit requests:", error)
    }
  }

  const reviewEditRequest = async (requestId, action) => {
    const user = JSON.parse(localStorage.getItem("dataUser"))
    let reviewNote = ""

    if (action === "reject") {
      const result = await Swal.fire({
        title: "Motivo del rechazo",
        input: "textarea",
        inputPlaceholder: "Escriba el motivo del rechazo",
        showCancelButton: true,
        confirmButtonText: "Rechazar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#c71c22",
      })
      if (!result.isConfirmed || !result.value?.trim()) return
      reviewNote = result.value.trim()
    }

    try {
      setLoading(true)
      await axios.post(
        `${ENDPOINT}ticket-edit-requests/${requestId}/${action}`,
        { user_id: user.user_id, review_note: reviewNote },
      )
      await getEditRequests()
      await getAll()
      Swal.fire({
        icon: "success",
        title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
        text: action === "approve" ? "Edición aprobada" : "Solicitud rechazada",
        timer: 2500,
        showConfirmButton: false,
      })
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
        text: error.response?.data?.msg || "No fue posible revisar la solicitud",
      })
    } finally {
      setLoading(false)
    }
  }

  const getEditRequestSummary = (editRequest) => {
    try {
      const changes = JSON.parse(editRequest.requested_data || "{}")
      const labels = {
        name: "Nombre",
        last_name: "Apellidos",
        email: "Email",
        phone: "Teléfono",
        origin_id: "Origen",
        destination_id: "Destino",
        price_ticket: "Precio",
        seat: "Asiento",
        card_payment: "Pago con tarjeta",
        card_payment_transfer: "Pago con transferencia",
        where_up: "Lugar de abordaje",
      }
      return Object.entries(changes)
        .map(([field, value]) => `${labels[field] || field}: ${value || "(vacío)"}`)
        .join(" | ")
    } catch (error) {
      return "Campos solicitados no disponibles"
    }
  }

  // Función para renderizar asientos
  const renderSeat = (number) => {
    if (!number) return <div className="seat-space" key={`space-${Math.random()}`} />

    // Find the seat data if it exists
    const seatInfo = seatData?.find((seat) => seat.seat === number)
    const isOccupied = seatInfo && seatInfo.status === 1
    const isReserved = seatInfo && seatInfo.status === 2
    const isSelected = selectedSeat === number
    const isAvailable = !isOccupied && !isReserved

    return (
      <div
        className={`seat ${isOccupied ? "occupied" : ""} ${isReserved ? "reserved" : ""} ${isSelected ? "selected" : ""} ${isAvailable ? "available" : ""}`}
        onClick={() => isAvailable && handleSeatSelection(number)}
        key={number}
      >
        {number}
      </div>
    )
  }


  // Helpers for payment-methods editing: only one 'yes' allowed (or both 'no')
  const handleCardPaymentChange = (value) => {
    // if user is trying to set card yes while transfer is also yes, block it
    if (value === 1 && cardPaymentTransfer === 1) {
      Swal.fire({
        icon: "error",
        title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
        html: '<div class="text-custom-alert">Solo puede seleccionar un método de pago (tarjeta o transferencia) o ninguno.</div>',
        showClass: { popup: "animate__animated animate__fadeInDown" },
        hideClass: { popup: "animate__animated animate__fadeOutUp" },
      });
      return;
    }

    setCardPayment(value);
    // if user selects card payment yes, ensure transfer is set to no
    if (value === 1) {
      setCardPaymentTransfer(2);
    }
  };

  const handleCardPaymentTransferChange = (value) => {
    if (value === 1 && card_payment === 1) {
      Swal.fire({
        icon: "error",
        title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
        html: '<div class="text-custom-alert">Solo puede seleccionar un método de pago (tarjeta o transferencia) o ninguno.</div>',
        showClass: { popup: "animate__animated animate__fadeInDown" },
        hideClass: { popup: "animate__animated animate__fadeOutUp" },
      });
      return;
    }

    setCardPaymentTransfer(value);
    // if user selects transfer yes, ensure card payment is set to no
    if (value === 1) {
      setCardPayment(2);
    }
  };

  // Keep the two boolean flags from ever being both 'yes'
  useEffect(() => {
    if (card_payment === 1 && cardPaymentTransfer === 1) {
      // automatically turn off transfer if card was set to yes
      setCardPaymentTransfer(2);
    }
  }, [card_payment, cardPaymentTransfer]);

  const resetPaymentFields = () => {
    setPaymentMethod(0);
    setTransferNumber("");
  };


const handleSubmit = async (e) => {
  e.preventDefault();

   // Validar método de pago si el estado es Comprado
   

  if (status === 1 && paymentMethod === 3 && !transferNumber.trim()) {
    Swal.fire({
      icon: "error",
      title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
      html: '<div class="text-custom-alert">Debe ingresar el número de transferencia</div>',
      showClass: { popup: "animate__animated animate__fadeInDown" },
      hideClass: { popup: "animate__animated animate__fadeOutUp" },
    });
    return;
  }

  // ensure card/transfer flags are mutually exclusive when editing
  if (card_payment === 1 && cardPaymentTransfer === 1) {
    Swal.fire({
      icon: "error",
      title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
      html: '<div class="text-custom-alert">Solo puede seleccionar un método de pago (tarjeta o transferencia) o ninguno.</div>',
      showClass: { popup: "animate__animated animate__fadeInDown" },
      hideClass: { popup: "animate__animated animate__fadeOutUp" },
    });
    return;
  }

  const departure = new Date(`${date_ticket}T${time_ticket}`);
  const now = new Date();
  const diffMinutes = (departure - now) / (1000 * 60);

  if (rol_id === 3 && diffMinutes <= 25 && status !== 3) {
    Swal.fire({
      icon: "warning",
      title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
      html: '<div class="text-custom-alert">No puedes editar este boleto. Faltan menos de 25 minutos para el viaje.</div>',
      showClass: { popup: "animate__animated animate__fadeInDown" },
      hideClass: { popup: "animate__animated animate__fadeOutUp" },
    });
    return;
  }

  if (type === 3) {
    const user = JSON.parse(localStorage.getItem("dataUser"));

    if (rol_id === 3) {
      const requestedValues = {
        name,
        last_name,
        email,
        phone,
        origin_id,
        destination_id,
        price_ticket: price,
        seat,
        card_payment,
        card_payment_transfer: cardPaymentTransfer,
        where_up,
      }
      const changes = Object.fromEntries(
        Object.entries(requestedValues).filter(([field, value]) => {
          const originalValue = originalEditValues[field]
          if (["origin_id", "destination_id", "price_ticket", "seat", "card_payment", "card_payment_transfer"].includes(field)) {
            return Number(value || 0) !== Number(originalValue || 0)
          }
          return String(value ?? "") !== String(originalValue ?? "")
        }),
      )

      if (Object.keys(changes).length === 0) {
        Swal.fire({
          icon: "info",
          title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
          html: '<div class="text-custom-alert">No hay cambios para solicitar</div>',
        })
        return
      }

      setLoading(true);
      try {
        await axios.post(ENDPOINT + "ticket-edit-requests", {
          ticket_id,
          user_id: user.user_id,
          changes,
        });
        await getAll();
        $("#closemodal").trigger("click");
        Swal.fire({
          icon: "success",
          title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
          showConfirmButton: false,
          timer: 3000,
          html: '<div class="text-custom-alert">Solicitud de edición enviada y pendiente de aprobación</div>',
        });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
          showConfirmButton: true,
          html: '<div class="text-custom-alert">' + (error.response?.data?.msg || "No fue posible enviar la solicitud") + "</div>",
        });
      } finally {
        setLoading(false);
      }
      return;
    }

    setLoading(true);
    const user_id = user.user_id;
    await axios
      .put(ENDPOINT + "update-ticket/" + ticket_id, {
        name: name,
        last_name: last_name,
        email: email,
        phone: phone,
        origin_id: origin_id,
        destination_id: destination_id,
        price: price,
        seat: seat,
        card_payment: card_payment,
        card_payment_transfer: cardPaymentTransfer,
        user_edit: user_id,        
        user_id: assigned_user,
        where_up: where_up,
      })
      .then((response) => {
        getAll();
        setLoading(false);
        $("#closemodal").trigger("click");
        Swal.fire({
          icon: "success",
          title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
          showConfirmButton: false,
          timer: 3000,
          html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
          showClass: { popup: "animate__animated animate__fadeInDown" },
          hideClass: { popup: "animate__animated animate__fadeOutUp" },
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
          showConfirmButton: true,
          timer: 3000,
          html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
          showClass: { popup: "animate__animated animate__fadeInDown" },
          hideClass: { popup: "animate__animated animate__fadeOutUp" },
        });
      });
  } else if (type === 2) {
    if (status === 3 && !cancelNote.trim()) {
      Swal.fire({
        icon: "error",
        title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
        html: '<div class="text-custom-alert">Debe ingresar una nota de cancelación</div>',
        showClass: { popup: "animate__animated animate__fadeInDown" },
        hideClass: { popup: "animate__animated animate__fadeOutUp" },
      });
      return;
    }

    setLoading(true);
    const user = JSON.parse(localStorage.getItem("dataUser"));
    const user_id = user.user_id;
    await axios
      .put(ENDPOINT + "change-status-ticket/" + ticket_id, {
        status: status,
        cancel_note: status === 3 ? cancelNote : null,
        user_cancel: user_id,
        payment_method: status === 1 ? paymentMethod : null, 
        transfer_number: status === 1 && paymentMethod === 3 ? transferNumber : null, 
      })
      .then((response) => {
        getAll();
        setLoading(false);
        setPaymentMethod(0);
        setTransferNumber("");
        $("#closemodal").trigger("click");

        if (status === 1) {
          handlePrint(invoice);
        }

        Swal.fire({
          icon: "success",
          timer: 3000,
          html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
          showClass: { popup: "animate__animated animate__fadeInDown" },
          hideClass: { popup: "animate__animated animate__fadeOutUp" },
        });
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
          showConfirmButton: true,
          timer: 3000,
          html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
          showClass: { popup: "animate__animated animate__fadeInDown" },
          hideClass: { popup: "animate__animated animate__fadeOutUp" },
        });
      });
  }
};


  const handleClear = () => {
    window.location.reload()
  }

  const getAll = async () => {
    setLoading(true)
    const form = new FormData()
    const user = JSON.parse(localStorage.getItem("dataUser"))
    const user_id = user.user_id
    form.append("date_filter", date_filter)
    form.append("start_date_filter", startDateFilter)
    form.append("end_date_filter", endDateFilter)
    form.append("origin_filter", origin_filter)
    form.append("destination_filter", destination_filter)
    form.append("status_filter", status_filter)
    form.append("type_filter", type_filter)
    form.append("user_id", user_id)
    form.append("payment_filter", payment_filter)
    form.append("user_filter", user_filter)

    form.append("date_filter_type", dateFilterType)
    form.append("days_back", daysBack)

    try {
      const response = await axios.post(ENDPOINT + "get-all-tickets", form)
      setBuys(response.data.data.filter((e) => e.status === 1).length)
      setRol(response.data.usuario)
      setReserved(response.data.data.filter((e) => e.status === 2).length)
      setCanceled(response.data.data.filter((e) => e.status === 3).length)
      setPending(response.data.data.filter((e) => e.status === 4).length)
      setTickets(response.data.data)

      setSumUser13(response.data.sum_user_13 || 0)

      // Rebuild datatable after data update
      try {
        const table = $(".main").DataTable()
        table.destroy()
      } catch (dtDestroyErr) {
        // ignore errors if DataTable is not initialized yet
      }

      await new Promise((resolve) => setTimeout(resolve, 80))

      try {
        $(".main").DataTable({
          searching: true,
          destroy: true,
          retrieve: true,
          pageLength: 50,
          responsive: false,
          autoWidth: false,
          paging: true,
          ordering: false,
          sortable: true,
          processing: false,
          serverSide: false,
          bInfo: true,
          language: {
            decimal: "",
            emptyTable: "",
            info: "Mostrando _START_ a _END_ de _TOTAL_ registros",
            infoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
            infoFiltered: "(filtrado de un total de _MAX_ registros)",
            infoPostFix: "",
            thousands: ",",
            lengthMenu: "Mostrar _MENU_ registros",
            loadingRecords: "Cargando...",
            processing: "Procesando...",
            search: "Buscar:",
            paginate: {
              first: "<i class='fa-solid fa-circle-chevron-left'></i>",
              last: "<i class='fa-solid fa-circle-chevron-right'></i>",
              next: "<i class='fas fa-arrow-circle-right'></i>",
              previous: "<i class='fas fa-arrow-circle-left'></i>",
            },
            zeroRecords: "No hay registros",
            searchPlaceholder: "Buscar por número de folio",
          },
        })
      } catch (dtInitErr) {
        console.error("Error initializing DataTable:", dtInitErr)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const getAllOrigins = async () => {
    const response = await axios.get(ENDPOINT + "get-all-origins-ticket")
    const originsArray = response.data.data.map((element) => ({
      label: element.name,
      value: element.destination_id,
    }))
    const schedule = response.data.schedules.map((element) => ({
      label: element.time,
      value: element.schedule_id,
      branch_id: element.branch_id,
      capacity: element.capacity || 20,
    }))
    setOrigins(originsArray)
    setSchedule(schedule)
  }

  const getAllDestinations = async (origin_id) => {
    setDestinations([])
    const response = await axios.get(ENDPOINT + "get-all-destinations-ticket/" + origin_id)
    const destinationsArray = response.data.data.map((element) => ({
      label: element.name,
      value: element.destination_id,
    }))
    setDestinations(destinationsArray)
  }

  const getAvailableSchedules = async (origin_id, destination_id, date) => {
    setLoading(true)
    try {
      const form = new FormData()
      form.append("origin_id", origin_id)
      form.append("destination_id", destination_id)
      form.append("date", date)
      const response = await axios.post(ENDPOINT + "get-available-schedules", form)
      setAvailableSchedules(response.data.schedules || [])
      setLoading(false)
    } catch (error) {
      console.error("Error fetching available schedules:", error)
      setLoading(false)
      setAvailableSchedules([])
    }
  }

  const handleDetail = async (id) => {
    setLoading(true)
    try {
      const response = await axios.get(ENDPOINT + "get-ticket/" + id)
      setLoading(false)
      setInvoice(response.data.data.invoice)
      setTicketId(response.data.data.ticket_id)
      setName(response.data.data.name)
      setLastName(response.data.data.last_name)
      setEmail(response.data.data.email)
      setPhone(response.data.data.phone)
      setDateTicket(response.data.data.date_ticket)
      setTimeTicket(response.data.data.time_ticket)
      setSeat(response.data.data.seat)
      setStatus(response.data.data.status)
      setState(response.data.data.state)
      setScheduleId(response.data.data.schedule_id)
      setUserId(response.data.data.user_id)
      setPrice(response.data.data.price_ticket)
      setDateSale(response.data.data.date_sale)
      setTimeSale(response.data.data.time_sale)
      setPurChaseOrder(response.data.data.purchase_order)
      setOriginId(response.data.data.origin_id)
      getAllDestinations(response.data.data.origin_id)
      setDestinationId(response.data.data.destination_id)
      setNumberTicket(response.data.data.number_ticket)
      setWhereUp(response.data.data.where_up)
      setDateCreated(response.data.data.date_created)
      // detail view also convert to numbers
      setCardPayment(Number(response.data.data.card_payment) || 2)
      setCardPaymentTransfer(Number(response.data.data.card_payment_transfer) || 2)
      setBasePrice(Number.parseFloat(response.data.data.price_ticket))
      setPriceExtra(Number.parseFloat(response.data.data.extras.price_extra || 0))
      setPricePet(Number.parseFloat(response.data.data.extras.price_pet || 0))
      setCancelNote(response.data.data.cancel_note)
      setUserCancel(response.data.data.user_cancel)
      setDateCancel(response.data.data.date_cancel)
      setBoxOffice(response.data.data.box_office)
      setUserEdit(response.data.data.user_edit)
      setTransferNumber(response.data.data.transfer_number || "")
    setUpdatedNote(response.data.data.updated_note || "")
    setTransferInfo(response.data.data.transfer || "")
    setTransferApprovedBy(response.data.data.transfer_approved_by || "")
    setEditApprovedBy(response.data.data.edit_approved_by || "")
    setWhereUp(response.data.data.where_up)
      setDateUpdated(response.data.data.date_updated)
      calculateTotal(
        Number.parseFloat(response.data.data.price_ticket),
        Number.parseFloat(response.data.data.extras.price_extra || 0),
        Number.parseFloat(response.data.data.extras.price_pet || 0),
      )
      $("#origin_id_detail").removeClass("select2")
      $("#destination_id_detail").removeClass("select2")
      $("#status_detail").removeClass("select2")
      setTimeout(() => {
        $("#origin_id_detail").addClass("select2")
        $("#destination_id_detail").addClass("select2")
        $("#status_detail").addClass("select2")
        initializeSelect2Detail()
      }, 100)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const handleChangeStatus = async (id) => {
    setLoading(true)
    await axios
      .get(ENDPOINT + "get-ticket/" + id)
      .then((response) => {
        setLoading(false)
        setType(2)
        setTicketId(response.data.data.ticket_id)
        setInvoice(response.data.data.invoice)
        setName(response.data.data.name)
        setLastName(response.data.data.last_name)
        setDateTicket(response.data.data.date_ticket)
        setTimeTicket(response.data.data.time_ticket)
        setSeat(response.data.data.seat)
        if (rol_id === 3) {
          setStatus(1)
        } else {
          setStatus(Number.parseInt(response.data.data.status))
        }
        setTotalAmount(Number.parseFloat(response.data.data.total_amount))
        setCancelNote("") // Limpiar la nota al abrir el modal

        // Initialize select2 for status change
        setTimeout(() => {
          $("#status_change")
            .select2({
              width: "100%",
              dropdownParent: $("#modal-status"),
            })
            .on("select2:select", (e) => {
              // Manejar el evento de cambio de select2
              setStatus(Number.parseInt(e.target.value))
            })
        }, 100)
      })
      .catch((error) => {
        console.log(error)
        setLoading(false)
      })
  }

  const handleEdit = async (id) => {
    setLoading(true)
    await axios
      .get(ENDPOINT + "get-ticket/" + id)
      .then((response) => {
        setLoading(false)
        setType(3)
        setTitle("Editar boleto")
        setTicketId(response.data.data.ticket_id)
        setInvoice(response.data.data.invoice)
        setName(response.data.data.name)
        setLastName(response.data.data.last_name)
        setEmail(response.data.data.email)
        setPhone(response.data.data.phone)
        setDateTicket(response.data.data.date_ticket)
        setTimeTicket(response.data.data.time_ticket)
        setSeat(response.data.data.seat)
        // Forzar status a 1 si el rol es 3 (no admin)
        if (rol_id === 3) {
          setStatus(1)
        } else {
          setStatus(response.data.data.status)
        }
        setState(response.data.data.state)
        setScheduleId(response.data.data.schedule_id)
        setUserId(response.data.data.user_id)
        setPrice(response.data.data.price_ticket)
        setDateSale(response.data.data.date_sale)
        setTimeSale(response.data.data.time_sale)
        // read both flags and apply mutual-exclusion rule
        const cpVal = response.data.data.card_payment
        const cptVal = response.data.data.card_payment_transfer
        setCardPayment(cpVal)
        setCardPaymentTransfer(cptVal)
        if (cpVal === 1 && cptVal === 1) {
          // server sent both yes, force transfer to no
          setCardPaymentTransfer(2)
        }
        setPurChaseOrder(response.data.data.purchase_order)
        setOriginId(response.data.data.origin_id)
        getAllDestinations(response.data.data.origin_id)
        setDestinationId(response.data.data.destination_id)
        setNumberTicket(response.data.data.number_ticket)
        setWhereUp(response.data.data.where_up)
        setAssignedUser(response.data.data.user_id || 0)
        setOriginalEditValues({
          name: response.data.data.name,
          last_name: response.data.data.last_name,
          email: response.data.data.email,
          phone: response.data.data.phone,
          origin_id: response.data.data.origin_id,
          destination_id: response.data.data.destination_id,
          price_ticket: response.data.data.price_ticket,
          seat: response.data.data.seat,
          card_payment: response.data.data.card_payment,
          card_payment_transfer: response.data.data.card_payment_transfer,
          where_up: response.data.data.where_up,
        })
        $("#origin_id").removeClass("select2")
        $("#destination_id").removeClass("select2")
        $("#status").removeClass("select2")
        setTimeout(() => {
          $("#origin_id").addClass("select2")
          $("#destination_id").addClass("select2")
          $("#status").addClass("select2")
          initializeSelect2()
        }, 100)
      })
      .catch((error) => {
        console.log(error)
        setLoading(false)
      })
  }

  const handleExtras = async (id) => {
    setLoading(true)
    await axios
      .get(ENDPOINT + "get-ticket/" + id)
      .then((response) => {
        setLoading(false)
        setType(4)
        setTitle("Agregar Extras al Boleto")
        setTicketId(response.data.data.ticket_id)
        setInvoice(response.data.data.invoice)
        setStatus(response.data.data.status)
        setSeat(response.data.data.seat)
        setName(response.data.data.name)
        setLastName(response.data.data.last_name)
        setDateTicket(response.data.data.date_ticket)
        setTimeTicket(response.data.data.time_ticket)
        setBasePrice(Number.parseFloat(response.data.data.price_ticket))
        setPriceExtra(Number.parseFloat(response.data.data.extras.price_extra || 0))
        setPricePet(Number.parseFloat(response.data.data.extras.price_pet || 0))
        calculateTotal(
          Number.parseFloat(response.data.data.price_ticket),
          Number.parseFloat(response.data.data.extras.price_extra || 0),
          Number.parseFloat(response.data.data.extras.price_pet || 0),
        )
      })
      .catch((error) => {
        setLoading(false)
        console.log(error)
      })
  }

  const calculateTotal = (base, extra, pet) => {
    const total = base + extra + pet
    setTotalAmount(total)
  }

  const handleSubmitExtras = async (e) => {
    e.preventDefault()
    setLoading(true)
    const user = JSON.parse(localStorage.getItem("dataUser"))
    const user_id = user.user_id
    await axios
      .put(ENDPOINT + "update-ticket-extras/" + ticket_id, {
        invoice: invoice,
        price_extra: priceExtra,
        price_pet: pricePet,
        extraLuggage: 1,
        extraPet: 1,
        current_user_id: user_id,
      })
      .then((response) => {
        getAll()
        setLoading(false)
        $("#closemodal-extras").trigger("click")
        Swal.fire({
          icon: "success",
          title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
          showConfirmButton: false,
          timer: 3000,
          html: '<div class="text-custom-alert">Extras actualizados correctamente</div>',
          showClass: { popup: "animate__animated animate__fadeInDown" },
          hideClass: { popup: "animate__animated animate__fadeOutUp" },
        })
      })
      .catch((error) => {
        setLoading(false)
        Swal.fire({
          icon: "error",
          title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
          showConfirmButton: true,
          html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
          showClass: { popup: "animate__animated animate__fadeInDown" },
          hideClass: { popup: "animate__animated animate__fadeOutUp" },
        })
      })
  }

  const handleCancel = (id, name) => {
    Swal.fire({
      title: `¿Desea cancelar el boleto con el folio [ ${name} ] ?`,
      html: `
                <div class="form-group">
                    <label class="form-label text-start d-block mb-2">
                        <i class="fa-solid fa-comment me-2"></i>
                        Nota de Cancelación <span className="text-danger">*</span>
                    </label>
                    <textarea 
                        id="cancel-note" 
                        class="form-control" 
                        placeholder="Ingrese el motivo de la cancelación"
                        rows="3"
                        style="background-color: #ffffff; color: #0d47a1; border: 2px solid #033c73"
                    ></textarea>
                    <small class="text-muted d-block mt-1">
                        <i class="fa-solid fa-info-circle me-1"></i>
                        Este campo es obligatorio para cancelar el boleto
                    </small>
                </div>`,
      icon: "warning",
      confirmButtonText: "Sí, cancelar",
      confirmButtonColor: "#c71c22",
      showCancelButton: true,
      cancelButtonColor: "#c71c22",
      cancelButtonText: "No",
      preConfirm: () => {
        const note = Swal.getPopup().querySelector("#cancel-note").value
        if (!note.trim()) {
          Swal.showValidationMessage("Debe ingresar una nota de cancelación")
          return false
        }
        return note
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        const user = JSON.parse(localStorage.getItem("dataUser"))
        const user_id = user.user_id
        setLoading(true)
        try {
          const response = await axios.put(ENDPOINT + "cancel-ticket/" + id, {
            status: 3,
            cancel_note: result.value,
            user_cancel: user_id,
          })

          await getAll()

          Swal.fire({
            icon: "success",
            title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
            showConfirmButton: false,
            timer: 3000,
            html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
            showClass: { popup: "animate__animated animate__fadeInDown" },
            hideClass: { popup: "animate__animated animate__fadeOutUp" },
          })
        } catch (error) {
          const message = error?.response?.data?.msg || "Error al cancelar el boleto"
          Swal.fire({
            icon: "error",
            title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
            showConfirmButton: true,
            html: '<div class="text-custom-alert">' + message + "</div>",
            showClass: { popup: "animate__animated animate__fadeInDown" },
            hideClass: { popup: "animate__animated animate__fadeOutUp" },
          })
        } finally {
          setLoading(false)
        }
      }
    })
  }

  const handlePrint = async (invoice) => {
    setLoading(true)
    const user = JSON.parse(localStorage.getItem("dataUser"))
    const user_id = user.user_id
    const form = new FormData()
    form.append("invoice", invoice)
    form.append("user_id", user_id)
    const response = await axios.post(ENDPOINT + "print-pdf-ticket-invoice", form, { responseType: "blob" })
    const url = window.URL.createObjectURL(response.data)
    window.open(url, "_blank")
    setLoading(false)
  }

  const handleEmail = async (ticket_id) => {
    setLoading(true)
    await axios
      .get(ENDPOINT + "get-email-ticket/" + ticket_id)
      .then((response) => {
        getAll()
        setLoading(false)
        Swal.fire({
          icon: "success",
          title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
          showConfirmButton: false,
          timer: 3000,
          html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
          showClass: { popup: "animate__animated animate__fadeInDown" },
          hideClass: { popup: "animate__animated animate__fadeOutUp" },
        })
      })
      .catch((error) => {
        console.log(error)
        setLoading(false)
        Swal.fire({
          icon: "error",
          title: '<div class="title-custom-alert">' + TITLEALERT + "</div>",
          showConfirmButton: true,
          html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
          showClass: { popup: "animate__animated animate__fadeInDown" },
          hideClass: { popup: "animate__animated animate__fadeOutUp" },
        })
      })
  }

  const formatDate = (dateString) => {
    if (!dateString) return "";
    // Ensure the date string is treated as UTC by adding 'Z' if it's not there
    const utcDateString = dateString.endsWith('Z') ? dateString : dateString + 'Z';
    const date = new Date(utcDateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  

  const formatDateForAPI = (date) => {
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, "0")
    const day = date.getDate().toString().padStart(2, "0")
    return `${year}-${month}-${day}`
  }

  const formatTime = (timeString) => {
    if (!timeString) return ""
    const [hours, minutes] = timeString.split(":")
    const date = new Date()
    date.setHours(hours)
    date.setMinutes(minutes)
    const formattedMinutes = date.getMinutes().toString().padStart(2, "0")
    const ampm = date.getHours() >= 12 ? "PM" : "AM"
    const hours12 = date.getHours() % 12 || 12
    const formattedHours12 = hours12.toString().padStart(2, "0")
    return `${formattedHours12}:${formattedMinutes} ${ampm}`
  }

  // Handle date change in transfer modal
  const handleTransferDateChange = (date) => {
    setTransferDate(date)
    // Update available seats when date changes
    getAvailableSeats(selectedScheduleId, formatDateForAPI(date))
  }

  // Handle schedule change in transfer modal
  const handleScheduleChange = (e) => {
    const scheduleId = Number.parseInt(e.target.value)
    setSelectedScheduleId(scheduleId)
    getAvailableSeats(scheduleId, formatDateForAPI(transferDate))
  }

  const canEditRestrictedFields = rol_id === 1;
  const canEditRequestFields = rol_id === 1 || rol_id === 3;

  useEffect(() => {
  console.log("Origen seleccionado:", origin_id);
}, [origin_id]);

useEffect(() => {
  console.log("Destino seleccionado:", destination_id);
}, [destination_id]);

const [ticketTimers, setTicketTimers] = useState({});

useEffect(() => {
  const updateTimers = () => {
    const updatedTimers = {};
    tickets.forEach((ticket) => {
      const departure = new Date(`${ticket.date_ticket}T${ticket.time_ticket}`);
      const now = new Date();
      const diffMinutes = (departure - now) / (1000 * 60);
      updatedTimers[ticket.ticket_id] = {
        minutesDifference: diffMinutes,
        timeDifference: departure - now,
      };
    });
    setTicketTimers(updatedTimers);
  };

  updateTimers(); 
  const interval = setInterval(updateTimers, 30000); 
  return () => clearInterval(interval);
}, [tickets]);


  return (
    <div>
      {loading && <Loader />}

      <div className="modal fade" id="modal-detail" aria-labelledby="modal-detail" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header bg-header-modal py-2">
              <h5 className="modal-title fs-6 d-flex align-items-center mb-0">
                <i className="fa-solid fa-eye me-2"></i>
                Detalle del Boleto
              </h5>
              <button type="button" className="btn-close btn-sm" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body p-3">
              {/* Ticket Header Card */}
              <div className="mb-3">
                <div
                  className="ticket-info-card"
                  style={{
                    background: "linear-gradient(135deg, #033c73 0%, #0056b3 100%)",
                    borderRadius: "10px",
                    padding: "15px",
                    color: "white",
                    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div>
                      <div className="text-white-50 text-uppercase" style={{ fontSize: "0.7rem" }}>
                        Número de Boleto
                      </div>
                      <h3 className="mb-0 fw-bold" style={{ fontSize: "1.5rem" }}>
                        #{invoice}
                      </h3>
                    </div>
                    <div className="text-end">
                      <div className="text-white-50 text-uppercase" style={{ fontSize: "0.7rem" }}>
                        Estado
                      </div>
                      <span
                        className={`badge ${
                          status === 1
                            ? "bg-success"
                            : status === 2
                              ? "bg-warning"
                              : status === 3
                                ? "bg-danger"
                                : "bg-info"
                        } px-3 py-2`}
                      >
                        {status === 1
                          ? "Comprado"
                          : status === 2
                            ? "Reservado"
                            : status === 3
                              ? "Cancelado"
                              : "Pendiente"}
                      </span>
                    </div>
                  </div>
                  {status === 3 ? (
                    <div className="mt-3 pt-3 border-top border-white border-opacity-25">
                      <div className="row g-2">
                        <div className="col-6">
                          <div className="text-white-50" style={{ fontSize: "0.7rem" }}>
                            MOTIVO DE CANCELACIÓN
                          </div>
                          <div className="fw-semibold">{cancelNote}</div>
                        </div>
                        <div className="col-3">
                          <div className="text-white-50" style={{ fontSize: "0.7rem" }}>
                            USUARIO QUE CANCELO
                          </div>
                          <div className="fw-semibold">{user_cancel}</div>
                        </div>
                        <div className="col-3">
                          <div className="text-white-50" style={{ fontSize: "0.7rem" }}>
                            FECHA DE CANCELACÍON
                          </div>
                          <div className="fw-semibold">{formatDate(date_cancel)}</div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="mt-3 pt-3 border-top border-white border-opacity-25">
                    <div className="row g-2">
                      <div className="col-6">
                        <div className="text-white-50" style={{ fontSize: "0.7rem" }}>
                          PASAJERO
                        </div>
                        <div className="fw-semibold">
                          {name} {last_name}
                        </div>
                      </div>
                      <div className="col-4">
      <div className="text-white-50" style={{ fontSize: "0.7rem" }}>
        ¿DONDE SUBE?
      </div>
      <div className="fw-semibold">{where_up || "No especificado"}</div>
    </div>
                      <div className="col-2">
                        <div className="text-white-50" style={{ fontSize: "0.7rem" }}>
                          ASIENTO
                        </div>
                        <div className="fw-semibold">{seat}</div>
                      </div>
                      <div className="col-3">
                        <div className="text-white-50" style={{ fontSize: "0.7rem" }}>
                          FECHA Y HORARIO
                        </div>
                        <div className="fw-semibold">{`${date_ticket} ${time_ticket}`}</div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-3 pt-3 border-top border-white border-opacity-25">
                    <div className="row g-2">
                      <div className="col-6">
                        <div className="text-white-50" style={{ fontSize: "0.7rem" }}>
                          USUARIO QUE VENDIO
                        </div>
                        <div className="fw-semibold">{box_office}</div>
                      </div>
                      <div className="col-3">
                        <div className="text-white-50" style={{ fontSize: "0.7rem" }}>
                          USUARIO QUE EDITO
                        </div>
                        <div className="fw-semibold">{user_edit}</div>
                      </div>
                      <div className="col-3">
                        <div className="text-white-50" style={{ fontSize: "0.7rem" }}>
                          FECHA ACTUALIZACIÓN
                        </div>
                        <div className="fw-semibold">{formatDate(date_updated)}</div>
                      </div>
                      <div className="col-6">
                      <div className="text-white-50" style={{ fontSize: "0.7rem" }}>
                        FECHA Y HORA DE VENTA
                      </div>
                      <div className="fw-semibold">{`${formatDate(dateCreated)} ${time_sale}`}</div>
                    </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Información del Viaje */}
              <div className="mb-4">
                <div className="card border-0 shadow-sm">
                  <div className="card-body p-3" style={{ background: "#f8f9fa", borderRadius: "8px" }}>
                    <h6
                      className="card-title d-flex align-items-center mb-2"
                      style={{ fontSize: "0.9rem", color: "#033c73" }}
                    >
                      <i className="fa-solid fa-route me-2"></i>
                      Información del Viaje
                    </h6>
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1 me-3">
                        <div className="info-group p-2" style={{ background: "#fff", borderRadius: "8px" }}>
                          <div className="d-flex align-items-center">
                            <div className="me-2">
                              <i className="fa-solid fa-location-dot text-primary" style={{ fontSize: "1.2rem" }}></i>
                            </div>
                            <div>
                              <small className="text-muted d-block" style={{ fontSize: "0.7rem" }}>
                                Origen
                              </small>
                              <p className="mb-0 fw-bold text-primary" style={{ fontSize: "0.9rem" }}>
                                {origins.find((o) => o.value == origin_id)?.label || ""}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="px-2">
                        <i className="fa-solid fa-arrow-right-long text-secondary"></i>
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <div className="info-group p-2" style={{ background: "#fff", borderRadius: "8px" }}>
                          <div className="d-flex align-items-center">
                            <div className="me-2">
                              <i className="fa-solid fa-location-pin text-danger" style={{ fontSize: "1.2rem" }}></i>
                            </div>
                            <div>
                              <small className="text-muted d-block" style={{ fontSize: "0.7rem" }}>
                                Destino
                              </small>
                              <p className="mb-0 fw-bold text-primary" style={{ fontSize: "0.9rem" }}>
                                {destinations.find((d) => d.value == destination_id)?.label || ""}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Información del Pasajero */}
              <div className="mb-4">
                <div className="card border-0 shadow-sm">
                  <div className="card-body p-3" style={{ background: "#f8f9fa", borderRadius: "8px" }}>
                    <h6
                      className="card-title d-flex align-items-center mb-3"
                      style={{ fontSize: "0.9rem", color: "#033c73" }}
                    >
                      <i className="fa-solid fa-user me-2"></i>
                      Información del Pasajero
                    </h6>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <div className="info-group p-3" style={{ background: "#fff", borderRadius: "8px" }}>
                          <small className="text-muted d-block">Email</small>
                          <p className="mb-0 fw-bold">{email}</p>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="info-group p-3" style={{ background: "#fff", borderRadius: "8px" }}>
                          <small className="text-muted d-block">Teléfono</small>
                          <p className="mb-0 fw-bold">{phone}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-4">
                <div className="card border-0 shadow-sm">
                  <div className="card-body p-3" style={{ background: "#f8f9fa", borderRadius: "8px" }}>
                    <h6
                      className="card-title d-flex align-items-center mb-3"
                      style={{ fontSize: "0.9rem", color: "#033c73" }}
                    >
                      <i className="fa-solid fa-credit-card me-2"></i>
                      Método de Pago
                    </h6>
                    <div className="row g-3">
                      <div className="col-md-4">
                        <div className="info-group p-3" style={{ background: "#fff", borderRadius: "8px" }}>
                          <small className="text-muted d-block">Pago con tarjeta</small>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="metodoPago"
                              checked={card_payment === 1}
                              readOnly
                            />
                            <label className="form-check-label">
                              {card_payment === 1 ? "Sí" : "No"}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="info-group p-3" style={{ background: "#fff", borderRadius: "8px" }}>
                          <small className="text-muted d-block">Pago con transferencia</small>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="metodoTransferencia"
                              checked={cardPaymentTransfer === 1}
                              readOnly
                            />
                            <label className="form-check-label">
                              {cardPaymentTransfer === 1 ? "Sí" : "No"}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="info-group p-3" style={{ background: "#fff", borderRadius: "8px" }}>
                          <small className="text-muted d-block">Pago en efectivo</small>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="metodoEfectivo"
                              checked={card_payment === 2 && cardPaymentTransfer === 2}
                              readOnly
                            />
                            <label className="form-check-label">
                              {(card_payment === 2 && cardPaymentTransfer === 2) ? "Sí" : "No"}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              {/* Desglose de Precios */}
              <div className="card border-0 shadow-sm">
                <div className="card-body p-3" style={{ background: "#f8f9fa", borderRadius: "8px" }}>
                  <h6
                    className="card-title d-flex align-items-center mb-3"
                    style={{ fontSize: "0.9rem", color: "#033c73" }}
                  >
                    <i className="fa-solid fa-receipt me-2"></i>
                    Desglose de Precios
                  </h6>
                  <div className="row g-3">
                    <div className="col-md-4">
                      <div className="price-item p-3" style={{ background: "#fff", borderRadius: "8px" }}>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa-solid fa-tag text-primary me-2"></i>
                          <small className="text-muted">Precio Base</small>
                        </div>
                        <h5 className="mb-0 text-primary">${basePrice.toFixed(2)}</h5>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="price-item p-3" style={{ background: "#fff", borderRadius: "8px" }}>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa-solid fa-plus-circle text-success me-2"></i>
                          <small className="text-muted">Cargo Extra</small>
                        </div>
                        <h5 className="mb-0 text-success">${priceExtra.toFixed(2)}</h5>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="price-item p-3" style={{ background: "#fff", borderRadius: "8px" }}>
                        <div className="d-flex align-items-center mb-2">
                          <i className="fa-solid fa-paw text-warning me-2"></i>
                          <small className="text-muted">Cargo por Mascota</small>
                        </div>
                        <h5 className="mb-0 text-warning">${pricePet.toFixed(2)}</h5>
                      </div>
                    </div>
                  </div>

                  {/* Total */}
                  <div className="mt-4">
                    <div
                      className="card"
                      style={{
                        background: "linear-gradient(135deg, #033c73 0%, #0056b3 100%)",
                        borderRadius: "8px",
                        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                      }}
                    >
                      <div className="card-body p-3">
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="text-white">TOTAL A PAGAR:</span>
                          <h4 className="mb-0 text-white">${totalAmount.toFixed(2)}</h4>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Información Adicional - Solo para Admin */}
{rol_id === 1 && (
  <div className="mt-4">
    <div className="card border-0 shadow-sm">
      <div className="card-body p-3" style={{ background: "#f8f9fa", borderRadius: "8px" }}>
        <h6
          className="card-title d-flex align-items-center mb-3"
          style={{ fontSize: "0.9rem", color: "#033c73" }}
        >
          <i className="fa-solid fa-info-circle me-2"></i>
          Información Administrativa
        </h6>
        <div className="row g-3">
          <div className="col-md-4">
            <div className="info-group p-3" style={{ background: "#fff", borderRadius: "8px" }}>
              <small className="text-muted d-block">Referencia de Transferencia</small>
              <p className="mb-0 fw-bold">{transferNumber || "N/A"}</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="info-group p-3" style={{ background: "#fff", borderRadius: "8px" }}>
              <small className="text-muted d-block">Ediciones de Boletos</small>
              <p className="mb-0 fw-bold">{updatedNote || "N/A"}</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="info-group p-3" style={{ background: "#fff", borderRadius: "8px" }}>
              <small className="text-muted d-block">Aprobado por (edición)</small>
              <p className="mb-0 fw-bold">{editApprovedBy || "No aplica"}</p>
            </div>
          </div>
          <div className="col-md-8">
            <div className="info-group p-3" style={{ background: "#fff", borderRadius: "8px" }}>
              <small className="text-muted d-block">Transferencia</small>
              <p className="mb-0 fw-bold">{transferInfo || "N/A"}</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="info-group p-3" style={{ background: "#fff", borderRadius: "8px" }}>
              <small className="text-muted d-block">Aprobado por (transferencia)</small>
              <p className="mb-0 fw-bold">{transferApprovedBy || "No aplica"}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)}
                </div>
              </div>
            </div>
            <div className="modal-footer py-2">
              <button id="closemodal-detail" type="button" className="btn btn-danger btn-sm" data-bs-dismiss="modal">
                <i className="fa-solid fa-xmark me-1"></i>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="modal-edit" aria-labelledby="modal-edit" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header bg-header-modal py-2">
              <h5 className="modal-title fs-6 d-flex align-items-center mb-0">
                <i className="fa-solid fa-pen-to-square me-2"></i>
                Editar Boleto #{invoice}
              </h5>
              <button type="button" className="btn-close btn-sm" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <form id="formulario" onSubmit={handleSubmit}>
              <div className="modal-body p-3">
                {/* Header Card */}
                <div className="mb-3">
                  <div
                    className="ticket-info-card"
                    style={{
                      background: "linear-gradient(135deg, #033c73 0%, #0056b3 100%)",
                      borderRadius: "10px",
                      padding: "15px",
                      color: "white",
                      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <div>
                        <div className="text-white-50 text-uppercase" style={{ fontSize: "0.7rem" }}>
                          Número de Boleto
                        </div>
                        <h3 className="mb-0 fw-bold" style={{ fontSize: "1.5rem" }}>
                          #{invoice}
                        </h3>
                      </div>
                      <div className="text-end">
                        <div className="text-white-50 text-uppercase" style={{ fontSize: "0.7rem" }}>
                          Estado
                        </div>
                        <span
                          className={`badge ${
                            status === 1
                              ? "bg-success"
                              : status === 2
                                ? "bg-warning"
                                : status === 3
                                  ? "bg-danger"
                                  : "bg-info"
                          } px-3 py-2`}
                        >
                          {status === 1
                            ? "Comprado"
                            : status === 2
                              ? "Reservado"
                              : status === 3
                                ? "Cancelado"
                                : "Pendiente"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card border-0 shadow-sm">
                  <div className="card-body p-4" style={{ background: "#f8f9fa", borderRadius: "8px" }}>
                    <input type="hidden" onChange={(e) => setTicketId(e.target.value)} value={ticket_id} />

                   {/* Sección Ruta */}
                    <div className="mb-4">
                      <h6
                        className="card-title d-flex align-items-center mb-3"
                        style={{ fontSize: "0.9rem", color: "#033c73" }}
                      >
                        <i className="fa-solid fa-route me-2"></i>
                        Información de Ruta
                      </h6>
                      <div className="row g-3">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="form-label small text-muted d-block mb-2">
                              <i className="fa-solid fa-location-dot me-1"></i>
                              Origen
                            </label>
                            <select
                              className="form-control form-control-sm"
                              id="origin_id"
                              name="origin_id"
                              value={origin_id}
                              onChange={(e) => setOriginId(e.target.value)}
                              disabled={!canEditRequestFields}
                              required
                            >
                              <option value="">Seleccione origen</option>
                              {origins.map((item, index) => (
                                <option key={index} value={item.value}>
                                  {item.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="form-label small text-muted d-block mb-2">
                              <i className="fa-solid fa-location-pin me-1"></i>
                              Destino
                            </label>
                            <select
                              className="form-control form-control-sm"
                              id="destination_id"
                              name="destination_id"
                              value={destination_id}
                              onChange={(e) => setDestinationId(e.target.value)}
                              disabled={!canEditRequestFields}
                              required
                            >
                              <option value="">Seleccione destino</option>
                              {destinations.map((item, index) => (
                                <option key={index} value={item.value}>
                                  {item.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>



                    {/* Sección Pasajero */}
                    <div className="mb-4">
                      <h6
                        className="card-title d-flex align-items-center mb-3"
                        style={{ fontSize: "0.9rem", color: "#033c73" }}
                      >
                        <i className="fa-solid fa-user me-2"></i>
                        Información del Pasajero
                      </h6>
                      <div className="row g-3">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="form-label small text-muted d-block mb-2">
                              <i className="fa-solid fa-user-tag me-1"></i>
                              Nombres del pasajero <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              placeholder="Nombres del pasajero"
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                              disabled={!canEditRequestFields}
                              required
                              style={{
                                backgroundColor: "#fff",
                                border: "1px solid #dee2e6",
                                borderRadius: "6px",
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="form-label small text-muted d-block mb-2">
                              <i className="fa-solid fa-user-tag me-1"></i>
                              Apellidos del pasajero
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              placeholder="Apellidos del pasajero"
                              value={last_name}
                              onChange={(e) => setLastName(e.target.value)}
                              disabled={!canEditRequestFields}
                              style={{
                                backgroundColor: "#fff",
                                border: "1px solid #dee2e6",
                                borderRadius: "6px",
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="form-label small text-muted d-block mb-2">
                              <i className="fa-solid fa-envelope me-1"></i>
                              Email del pasajero 
                            </label>
                            <input
                              type="email"
                              className="form-control form-control-sm"
                              placeholder="Email del pasajero"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            
                              style={{
                                backgroundColor: "#fff",
                                border: "1px solid #dee2e6",
                                borderRadius: "6px",
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="form-label small text-muted d-block mb-2">
                              <i className="fa-solid fa-phone me-1"></i>
                              Teléfono del pasajero 
                            </label>
                            <input
                              type="tel"
                              className="form-control form-control-sm"
                              placeholder="Teléfono del pasajero"
                              value={phone}
                              onChange={(e) => setPhone(e.target.value)}
                              
                              style={{
                                backgroundColor: "#fff",
                                border: "1px solid #dee2e6",
                                borderRadius: "6px",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Sección Detalles */}
                    <div className="mb-4">
                      <h6
                        className="card-title d-flex align-items-center mb-3"
                        style={{ fontSize: "0.9rem", color: "#033c73" }}
                      >
                        <i className="fa-solid fa-ticket me-2"></i>
                        Detalles del Viaje
                      </h6>
                      <div className="row g-3">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label className="form-label small text-muted d-block mb-2">
                              <i className="fa-solid fa-chair me-1"></i>
                              Puesto del pasajero
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              placeholder="Puesto del pasajero"
                              value={seat}
                              onChange={(e) => setSeat(e.target.value)}
                              required
                              disabled={!canEditRequestFields}
                              style={{
                                backgroundColor: "#fff",
                                border: "1px solid #dee2e6",
                                borderRadius: "6px",
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label className="form-label small text-muted d-block mb-2">
                              <i className="fa-solid fa-dollar-sign me-1"></i>
                              Precio de venta
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              placeholder="Precio de venta"
                              value={price}
                              onChange={(e) => setPrice(e.target.value)}
                              required
                              disabled={!canEditRequestFields}
                              style={{
                                backgroundColor: "#fff",
                                border: "1px solid #dee2e6",
                                borderRadius: "6px",
                              }}
                            />
                          </div>
                        </div>
                        {rol_id !== 3 && <div className="col-md-3">
                          <div className="form-group">
                            <label className="form-label small text-muted d-block mb-2">
                              <i className="fa-solid fa-calendar-day me-1"></i>
                              Fecha de viaje <span className="text-danger">*</span>
                            </label>
                            <input
                              type="date"
                              className="form-control form-control-sm mb-1"
                              placeholder="Fecha de viaje"
                              value={date_ticket}
                              onChange={(e) => setDateTicket(e.target.value)}
                              required
                              disabled={true}
                              style={{
                                backgroundColor: "#fff",
                                border: "1px solid #dee2e6",
                                borderRadius: "6px",
                              }}
                            />
                          </div>
                        </div>}
                        {rol_id !== 3 && <div className="col-md-3">
                          <div className="form-group">
                            <label className="form-label small text-muted d-block mb-2">
                              <i className="fa-solid fa-clock me-1"></i>
                              Hora de viaje <span className="text-danger">*</span>
                            </label>
                            <input
                              type="time"
                              className="form-control form-control-sm"
                              placeholder="Hora de viaje"
                              value={time_ticket}
                              onChange={(e) => setTimeTicket(e.target.value)}
                              required
                              disabled={true}
                              style={{
                                backgroundColor: "#fff",
                                border: "1px solid #dee2e6",
                                borderRadius: "6px",
                              }}
                            />
                          </div>
                        </div>}
                        {rol_id !== 3 && <div className="col-md-3">
                          <div className="form-group">
                            <label className="form-label small text-muted d-block mb-2">
                              <i className="fa-solid fa-calendar-check me-1"></i>
                              Fecha de venta
                            </label>
                            <input
                              type="date"
                              className="form-control form-control-sm"
                              placeholder="Fecha de venta"
                              value={date_sale}
                              onChange={(e) => setDateSale(e.target.value)}
                              required
                              disabled={true}
                              style={{
                                backgroundColor: "#fff",
                                border: "1px solid #dee2e6",
                                borderRadius: "6px",
                              }}
                            />
                          </div>
                        </div>}
                        {rol_id !== 3 && <div className="col-md-3">
                          <div className="form-group">
                            <label className="form-label small text-muted d-block mb-2">
                              <i className="fa-solid fa-clock me-1"></i>
                              Hora de venta
                            </label>
                            <input
                              type="time"
                              className="form-control form-control-sm"
                              placeholder="Hora de venta"
                              value={time_sale}
                              onChange={(e) => setTimeSale(e.target.value)}
                              required
                              disabled={true}
                              style={{
                                backgroundColor: "#fff",
                                border: "1px solid #dee2e6",
                                borderRadius: "6px",
                              }}
                            />
                          </div>
                        </div>}
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="form-label small text-muted d-block mb-2">
                              <i className="fa-solid fa-location-crosshairs"></i>
                              ¿Dondé Suben?
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              placeholder="¿Dondé Suben?"
                              value={where_up}
                              onChange={(e) => setWhereUp(e.target.value)}
                              style={{
                                backgroundColor: "#fff",
                                border: "1px solid #dee2e6",
                                borderRadius: "6px",
                              }}
                            />
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-6">
                            <label className="form-label d-block">Pago con tarjeta</label>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                className="form-check-input"
                                id="edit_card_yes"
                                name="card_payment"
                                checked={card_payment === 1}
                                onChange={() => handleCardPaymentChange(1)}
                                disabled={!canEditRequestFields || cardPaymentTransfer === 1}
                              />
                              <label className="form-check-label" htmlFor="edit_card_yes">Sí</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                className="form-check-input"
                                id="edit_card_no"
                                name="card_payment"
                                checked={card_payment === 2}
                                onChange={() => handleCardPaymentChange(2)}
                                disabled={!canEditRequestFields}
                              />
                              <label className="form-check-label" htmlFor="edit_card_no">No</label>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <label className="form-label d-block">Pago con transferencia</label>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                className="form-check-input"
                                id="edit_transfer_yes"
                                name="cardPaymentTransfer"
                                checked={cardPaymentTransfer === 1}
                                onChange={() => handleCardPaymentTransferChange(1)}
                                disabled={!canEditRequestFields || card_payment === 1}
                              />
                              <label className="form-check-label" htmlFor="edit_transfer_yes">Sí</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                className="form-check-input"
                                id="edit_transfer_no"
                                name="cardPaymentTransfer"
                                checked={cardPaymentTransfer === 2}
                                onChange={() => handleCardPaymentTransferChange(2)}
                                disabled={!canEditRequestFields}
                              />
                              <label className="form-check-label" htmlFor="edit_transfer_no">No</label>
                            </div>
                          </div>
                        </div>

                        {rol_id !== 3 && rol_id !== 10&& (
  <div className="col-md-6">
    <div className="form-group">
      <label className="col-form-label col-form-label-sm">
        Asignar a usuario
      </label>
      <select
        className="form-control form-control-sm"
        value={assigned_user}
        onChange={(e) => setAssignedUser(e.target.value)}
        disabled={!canEditRestrictedFields}
        style={{
          backgroundColor: "#fff",
          border: "1px solid #dee2e6",
          borderRadius: "6px",
        }}
      >
        <option value="0">Seleccione usuario</option>
        {users.map((item, index) => (
          <option key={index} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
    </div>
  </div>
)}    


                        <div className="col-md-3 d-none">
                          <div className="form-group">
                            <label className="form-label small text-muted d-block mb-2">
                              <i className="fa-solid fa-info-circle me-1"></i>
                              Estado del boleto <span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-control form-control-sm"
                              id="status"
                              name="status"
                              value={status}
                              onChange={(e) => setStatus(Number(e.target.value))}
                              required
                              style={{
                                backgroundColor: "#fff",
                                border: "1px solid #dee2e6",
                                borderRadius: "6px",
                              }}
                            >
                              {status_trip.map((item, index) => (
                                <option key={index} value={item.value}>
                                  {item.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer py-2">
                <button type="submit" className="btn btn-success btn-sm">
                  <i className="fa-regular fa-floppy-disk me-1"></i>
                  Guardar Cambios
                </button>
                <button id="closemodal" type="button" className="btn btn-danger btn-sm" data-bs-dismiss="modal">
                  <i className="fa-solid fa-xmark me-1"></i>
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="modal fade" id="modal-extras" aria-labelledby="modal-extras" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-header-modal py-2">
              <h5 className="modal-title fs-6 d-flex align-items-center mb-0">
                <i className="fa-solid fa-circle-plus me-2"></i>
                Agregar Extras al Boleto
              </h5>
              <button type="button" className="btn-close btn-sm" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <form onSubmit={handleSubmitExtras}>
              <div className="modal-body p-3">
                {/* Ticket Header Card */}
                <div className="mb-3">
                  <div
                    className="ticket-info-card"
                    style={{
                      background: "linear-gradient(135deg, #033c73 0%, #0056b3 100%)",
                      borderRadius: "10px",
                      padding: "15px",
                      color: "white",
                      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <div>
                        <div className="text-white-50 text-uppercase" style={{ fontSize: "0.7rem" }}>
                          Número de Boleto
                        </div>
                        <h3 className="mb-0 fw-bold" style={{ fontSize: "1.5rem" }}>
                          #{invoice}
                        </h3>
                      </div>
                      <div className="text-end">
                        <div className="text-white-50 text-uppercase" style={{ fontSize: "0.7rem" }}>
                          Estado
                        </div>
                        <span
                          className={`badge ${
                            status === 1
                              ? "bg-success"
                              : status === 2
                                ? "bg-warning"
                                : status === 3
                                  ? "bg-danger"
                                  : "bg-info"
                          } px-3 py-2`}
                        >
                          {status === 1
                            ? "Comprado"
                            : status === 2
                              ? "Reservado"
                              : status === 3
                                ? "Cancelado"
                                : "Pendiente"}
                        </span>
                      </div>
                    </div>
                    <div className="mt-3 pt-3 border-top border-white border-opacity-25">
                      <div className="row g-2">
                        <div className="col-6">
                          <div className="text-white-50" style={{ fontSize: "0.7rem" }}>
                            PASAJERO
                          </div>
                          <div className="fw-semibold">
                            {name} {last_name}
                          </div>
                        </div>
                        <div className="col-3">
                          <div className="text-white-50" style={{ fontSize: "0.7rem" }}>
                            ASIENTO
                          </div>
                          <div className="fw-semibold">{seat}</div>
                        </div>
                        <div className="col-3">
                          <div className="text-white-50" style={{ fontSize: "0.7rem" }}>
                            FECHA / HORA
                          </div>
                          <div className="fw-semibold">
                            {formatDate(date_ticket)} {formatTime(time_ticket)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Price Breakdown Section */}
                <div className="price-breakdown-section mb-3">
                  <div className="card border-0 shadow-sm">
                    <div className="card-body p-3" style={{ background: "#f8f9fa", borderRadius: "8px" }}>
                      <h6
                        className="card-title d-flex align-items-center mb-3"
                        style={{ fontSize: "0.9rem", color: "#033c73" }}
                      >
                        <i className="fa-solid fa-receipt me-2"></i>
                        Desglose de Precios Base
                      </h6>
                      <div className="price-list">
                        <div className="price-item d-flex justify-content-between align-items-center mb-2">
                          <div className="d-flex align-items-center">
                            <i className="fa-solid fa-tag me-2 text-primary"></i>
                            <span style={{ fontSize: "0.85rem" }}>Precio Base del Boleto</span>
                          </div>
                          <span className="fw-bold text-primary">${basePrice.toFixed(2)}</span>
                        </div>
                        <hr className="my-2" style={{ opacity: "0.1" }} />
                        <div className="summary-row d-flex justify-content-between align-items-center">
                          <span className="text-muted" style={{ fontSize: "0.8rem" }}>
                            Subtotal Base
                          </span>
                          <span className="fw-bold" style={{ color: "#033c73" }}>
                            ${basePrice.toFixed(2)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Extras Input Section */}
                <div className="extras-input-section mb-3">
                  <div className="card border-0 shadow-sm">
                    <div className="card-body p-3" style={{ background: "#fff" }}>
                      <h6
                        className="card-title d-flex align-items-center mb-3"
                        style={{ fontSize: "0.9rem", color: "#033c73" }}
                      >
                        <i className="fa-solid fa-plus-circle me-2"></i>
                        Cargos Adicionales
                      </h6>
                      <div className="row g-3">
                        <div className="col-6">
                          <label className="form-label d-flex align-items-center" style={{ fontSize: "0.8rem" }}>
                            <i className="fa-solid fa-box text-primary me-2"></i>
                            Cargo Extra
                          </label>
                          <div className="input-group input-group-sm">
                            <span className="input-group-text" style={{ background: "#033c73", color: "white" }}>
                              $
                            </span>
                            <input
                              type="number"
                              className="form-control"
                              value={priceExtra}
                              onChange={(e) => {
                                const value = Number.parseFloat(e.target.value) || 0
                                setPriceExtra(value)
                                calculateTotal(basePrice, value, pricePet)
                              }}
                              min="0"
                              step="0.01"
                              style={{ fontSize: "0.9rem" }}
                            />
                        </div>
                        </div>
                        <div className="col-6">
                          <label className="form-label d-flex align-items-center" style={{ fontSize: "0.8rem" }}>
                            <i className="fa-solid fa-paw text-warning me-2"></i>
                            Cargo por Mascota
                          </label>
                          <div className="input-group input-group-sm">
                            <span className="input-group-text" style={{ background: "#ffc107", color: "black" }}>
                              $
                            </span>
                            <input
                              type="number"
                              className="form-control"
                              value={pricePet}
                              onChange={(e) => {
                                const value = Number.parseFloat(e.target.value) || 0
                                setPricePet(value)
                                calculateTotal(basePrice, priceExtra, value)
                              }}
                              min="0"
                              step="0.01"
                              style={{ fontSize: "0.9rem" }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Total Summary Section */}
                <div className="total-summary-section">
                  <div
                    className="card border-0"
                    style={{
                      background: "linear-gradient(135deg, #033c73 0%, #0056b3 100%)",
                      borderRadius: "10px",
                      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                    }}
                  >
                    <div className="card-body p-3">
                      <div className="total-breakdown">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="text-white-50" style={{ fontSize: "0.8rem" }}>
                            Precio Base:
                          </span>
                          <span className="text-white">${basePrice.toFixed(2)}</span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="text-white-50" style={{ fontSize: "0.8rem" }}>
                            Cargo Extra:
                          </span>
                          <span className="text-white">+${priceExtra.toFixed(2)}</span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <span className="text-white-50" style={{ fontSize: "0.8rem" }}>
                            Cargo por Mascota:
                          </span>
                          <span className="text-white">+${pricePet.toFixed(2)}</span>
                        </div>
                        <div className="border-top border-white border-opacity-25 pt-2 mt-2">
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="text-white" style={{ fontSize: "0.9rem" }}>
                              TOTAL A PAGAR:
                            </span>
                            <span className="text-white fw-bold" style={{ fontSize: "1.4rem" }}>
                              ${totalAmount.toFixed(2)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer py-2">
                <button type="submit" className="btn btn-success btn-sm">
                  <i className="fa-regular fa-floppy-disk me-1"></i>
                  Guardar
                </button>
                <button id="closemodal-extras" type="button" className="btn btn-danger btn-sm" data-bs-dismiss="modal">
                  <i className="fa-solid fa-xmark me-1"></i>
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="modal fade" id="modal-status" aria-labelledby="modal-status" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-header-modal py-2">
              <h5 className="modal-title fs-6 d-flex align-items-center mb-0">
                <i className="fa-solid fa-arrows-rotate me-2"></i>
                Cambiar Estado del Boleto
              </h5>
              <button type="button" className="btn-close btn-sm" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body p-3">
                {/* Ticket Header Card */}
                <div className="mb-3">
                  <div
                    className="ticket-info-card"
                    style={{
                      background: "linear-gradient(135deg, #033c73 0%, #0056b3 100%)",
                      borderRadius: "10px",
                      padding: "15px",
                      color: "white",
                      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <div>
                        <div className="text-white-50 text-uppercase" style={{ fontSize: "0.7rem" }}>
                          Número de Boleto
                        </div>
                        <h3 className="mb-0 fw-bold" style={{ fontSize: "1.5rem" }}>
                          #{invoice}
                        </h3>
                      </div>
                      <div className="text-end">
                        <div className="text-white-50 text-uppercase" style={{ fontSize: "0.7rem" }}>
                          Estado Actual
                        </div>
                        <span
                          className={`badge ${
                            status === 1
                              ? "bg-success"
                              : status === 2
                                ? "bg-warning"
                                : status === 3
                                  ? "bg-danger"
                                  : "bg-info"
                          } px-3 py-2`}
                        >
                          {status === 1
                            ? "Comprado"
                            : status === 2
                              ? "Reservado"
                              : status === 3
                                ? "Cancelado"
                                : "Pendiente"}
                        </span>
                      </div>
                    </div>
                    <div className="mt-3 pt-3 border-top border-white border-opacity-25">
                      <div className="row g-2">
                        <div className="col-6">
                          <div className="text-white-50" style={{ fontSize: "0.7rem" }}>
                            PASAJERO
                          </div>
                          <div className="fw-semibold">
                            {name} {last_name}
                          </div>
                        </div>
                        <div className="col-3">
                          <div className="text-white-50" style={{ fontSize: "0.7rem" }}>
                            ASIENTO
                          </div>
                          <div className="fw-semibold">{seat}</div>
                        </div>
                        <div className="col-3">
                          <div className="text-white-50" style={{ fontSize: "0.7rem" }}>
                            FECHA
                          </div>
                          <div className="fw-semibold">{formatDate(date_ticket)}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Price Summary Card */}
                <div className="mb-4">
                  <div className="card border-0 shadow-sm">
                    <div className="card-body p-3" style={{ background: "#f8f9fa", borderRadius: "8px" }}>
                      <h6
                        className="card-title d-flex align-items-center mb-3"
                        style={{ fontSize: "0.9rem", color: "#033c73" }}
                      >
                        <i className="fa-solid fa-receipt me-2"></i>
                        Resumen de Precios
                      </h6>
                      <div className="row g-3">
                        <div className="col-md-4">
                          <div className="price-item p-3" style={{ background: "#fff", borderRadius: "8px" }}>
                            <div className="d-flex align-items-center mb-2">
                              <i className="fa-solid fa-tag text-primary me-2"></i>
                              <small className="text-muted">Precio Base</small>
                            </div>
                            <h5 className="mb-0 text-primary">${basePrice.toFixed(2)}</h5>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="price-item p-3" style={{ background: "#fff", borderRadius: "8px" }}>
                            <div className="d-flex align-items-center mb-2">
                              <i className="fa-solid fa-plus-circle text-success me-2"></i>
                              <small className="text-muted">Cargo Extra</small>
                            </div>
                            <h5 className="mb-0 text-success">${priceExtra.toFixed(2)}</h5>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="price-item p-3" style={{ background: "#fff", borderRadius: "8px" }}>
                            <div className="d-flex align-items-center mb-2">
                              <i className="fa-solid fa-paw text-warning me-2"></i>
                              <small className="text-muted">Cargo Mascota</small>
                            </div>
                            <h5 className="mb-0 text-warning">${pricePet.toFixed(2)}</h5>
                          </div>
                        </div>
                      </div>
                      <div className="mt-3">
                        <div
                          className="card"
                          style={{
                            background: "linear-gradient(135deg, #033c73 0%, #0056b3 100%)",
                            borderRadius: "8px",
                            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                          }}
                        >
                          <div className="card-body p-3">
                            <div className="d-flex justify-content-between align-items-center">
                              <span className="text-white">TOTAL A PAGAR:</span>
                              <h4 className="mb-0 text-white">${totalAmount.toFixed(2)}</h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Status Selection Card */}
<div className="card border-0 shadow-sm">
  <div className="card-body p-3" style={{ background: "#f8f9fa", borderRadius: "8px" }}>
    <h6 className="card-title d-flex align-items-center mb-3" style={{ fontSize: "0.9rem", color: "#033c73" }}>
      <i className="fa-solid fa-list-check me-2"></i>
      Cambio de Estado
    </h6>
    <div className="form-group">
      <select
        className="form-select"
        id="status_change"
        name="status"
        required
        onChange={(e) => setStatus(Number.parseInt(e.target.value))}
        value={status}
        style={{
          backgroundColor: "#ffffff",
          color: "#033c73",
          border: "2px solid #033c73",
          borderRadius: "8px",
          padding: "0.75rem",
        }}
      >
        {filteredStatusTrip.map((item, index) => (
          <option key={index} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
    </div>

    {/* Sección de Método de Pago (solo para estado Comprado) */}
    {status === 1 && (
      <div className="mt-3">
        <label className="form-label d-flex align-items-center" style={{ fontSize: "0.9rem", color: "#033c73" }}>
          <i className="fa-solid fa-credit-card me-2"></i>
          Método de Pago <span className="text-danger">*</span>
        </label>
        
        <div className="row g-2">
          <div className="col-md-4">
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="paymentMethod"
                id="paymentCash"
                value="1"
                checked={paymentMethod === 1}
                onChange={() => setPaymentMethod(1)}
                required={status === 1}
              />
              <label className="form-check-label" htmlFor="paymentCash">
                Efectivo
              </label>
            </div>
          </div>
          
          <div className="col-md-4">
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="paymentMethod"
                id="paymentCard"
                value="2"
                checked={paymentMethod === 2}
                onChange={() => setPaymentMethod(2)}
                required={status === 1}
              />
              <label className="form-check-label" htmlFor="paymentCard">
                Tarjeta
              </label>
            </div>
          </div>
          
          <div className="col-md-4">
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="paymentMethod"
                id="paymentTransfer"
                value="3"
                checked={paymentMethod === 3}
                onChange={() => setPaymentMethod(3)}
                required={status === 1}
              />
              <label className="form-check-label" htmlFor="paymentTransfer">
                Transferencia
              </label>
            </div>
          </div>
        </div>
        
        {/* Campo para número de transferencia */}
        {paymentMethod === 3 && (
          <div className="mt-2">
            <label className="form-label small">
              Número de Referencia/Transferencia <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Ingrese el número de referencia"
              value={transferNumber}
              onChange={(e) => setTransferNumber(e.target.value)}
              required={paymentMethod === 3}
              style={{
                backgroundColor: "#ffffff",
                color: "#033c73",
                border: "2px solid #033c73",
                borderRadius: "8px",
              }}
            />
          </div>
        )}
      </div>
    )}

    {/* Campo de nota de cancelación condicional */}
    {status === 3 && (
      <div className="form-group mt-3">
        <label
          className="form-label d-flex align-items-center"
          style={{ fontSize: "0.9rem", color: "#033c73" }}
        >
          <i className="fa-solid fa-comment me-2"></i>
          Nota de Cancelación <span className="text-danger">*</span>
        </label>
        <textarea
          className="form-control form-control-sm"
          placeholder="Ingrese el motivo de la cancelación"
          value={cancelNote}
          onChange={(e) => setCancelNote(e.target.value)}
          required
          rows="3"
          style={{
            backgroundColor: "#ffffff",
            color: "#033c73",
            border: "2px solid #033c73",
            borderRadius: "8px",
            height: "100px",
            resize: "none",
          }}
        ></textarea>
        <small className="text-muted d-flex align-items-center mt-2">
          <i className="fa-solid fa-info-circle me-2"></i>
          Este campo es obligatorio para cancelar el boleto
        </small>
      </div>
    )}
  </div>
</div>
              </div>
              <div className="modal-footer py-2">
                <button type="submit" className="btn btn-success btn-sm">
                  <i className="fa-regular fa-floppy-disk me-1"></i>
                  Guardar Cambios
                </button>
                <button id="closemodal-status" type="button" className="btn btn-danger btn-sm" data-bs-dismiss="modal" onClick={resetPaymentFields}>
                  <i className="fa-solid fa-xmark me-1"></i>
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <ContentHeader title="Módulo de Boletos" />
      </div>

      <div className="container-fluid">
        <div className="card">
          <div className="card-header">
            <div className="indications-header row">
              <div className="col-md-6">
                <h4 className="card-title m-0 page-title">
                  <i className="bi bi-person-lines-fill me-2"></i>Listado de Boletos
                </h4>
              </div>
              <div className="col-md-6" style={{ textAlign: "right" }}>
                <Link to="/agregar-boleto" className="btn btn-success btn-sm me-1">
                  <i className="fa-solid fa-magnifying-glass-plus me-1"></i> Agregar boleta
                </Link>
                <button onClick={handleCollapse} className="btn btn-warning btn-sm me-1" type="button">
                  <i className="fa-solid fa-filter me-1"></i> Filtros
                </button>
                <button onClick={() => window.location.reload()} className="btn btn btn-info btn-sm me-1" type="button">
                  <i className="fa fa-refresh me-1"></i> Recargar
                </button>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className={`indications filter filter-transition ${collapseFilters ? "expanded" : "collapsed"}`}>

              <form>
                {/** Indications */}
                <div className="list-ticket-form-header">
                  <h3 className="list-package-form-title">
                    <i className="bi bi-funnel me-2"></i>
                    Filtros de Búsqueda
                  </h3>
                  <p className="list-ticket-form-subtitle">
                    Utilice los filtros para encontrar boletos específicos
                    <hr className="mt-2" />
                  </p>
                </div>
                <div className="list-ticket-indications row mb-4">


                <div className="col-md-2 col-sm-6 mb-2">
  <div className="form-group">
    <label className="col-form-label col-form-label-sm">
      Tipo de Fecha <span className="list-ticket-required">*</span>
    </label>
    <div className="form-check form-switch">
      <input
        className="form-check-input"
        type="checkbox"
        id="dateFilterSwitch"
        checked={dateFilterType === 'date_sale'}
        onChange={(e) => setDateFilterType(e.target.checked ? 'date_sale' : 'date_ticket')}
      />
      <label className="form-check-label" htmlFor="dateFilterSwitch">
        {dateFilterType === 'date_sale' ? 'Fecha de Venta' : 'Fecha de Viaje'}
      </label>
    </div>
    <small className="list-ticket-field-hint">
      {dateFilterType === 'date_sale' 
        ? 'Buscar por fecha de venta' 
        : 'Buscar por fecha de viaje'}
    </small>
  </div>
</div>

                <div className="col-md-2 col-sm-6 mb-2">
  <div className="form-group">
    <label htmlFor="date_filter" className="col-form-label col-form-label-sm">
      Fecha <span className="list-ticket-required">*</span>
    </label>
    {rol_id === 1 ? (
      <>
        <input
          type="date"
          className="form-control form-control-sm mb-1"
          id="start_date_filter"
          name="start_date_filter"
          value={startDateFilter}
          onChange={(e) => setStartDateFilter(e.target.value)}
        />
        <input
          type="date"
          className="form-control form-control-sm"
          id="end_date_filter"
          name="end_date_filter"
          value={endDateFilter}
          onChange={(e) => setEndDateFilter(e.target.value)}
        />
        <small className="list-ticket-field-hint">Rango de fechas (desde - hasta)</small>
      </>
    ) : (
      <>
        <input
          type="date"
          className="form-control form-control-sm"
          id="date_filter"
          name="date_filter"
          value={date_filter}
          onChange={(e) => setDateFilter(e.target.value)}
        />
        <small className="list-ticket-field-hint">Filtrar por fecha de viaje</small>
      </>
    )}
  </div>
</div>
                  <div className="col-md-2 col-sm-6 mb-2">
                    <div className="form-group">
                      <label htmlFor="origin_filter" className="col-form-label col-form-label-sm">
                        Origen <span className="list-ticket-required">*</span>
                      </label>
                      <select
                        className="form-control form-control-sm select2"
                        id="origin_filter"
                        name="origin_filter"
                        required
                      >
                        <option value="0">Seleccione</option>
                        {origins.map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                      <small className="list-ticket-field-hint">Filtrar por ciudad de origen</small>
                    </div>
                  </div>
                  <div className="col-md-2 col-sm-6 mb-2">
                    <div className="form-group">
                      <label htmlFor="destination_filter" className="col-form-label col-form-label-sm">
                        Destino <span className="list-ticket-required">*</span>
                      </label>
                      <select
                        className="form-control form-control-sm select2"
                        id="destination_filter"
                        name="destination_filter"
                      >
                        <option value="0">Seleccione</option>
                        {destinations.map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                      <small className="list-ticket-field-hint">Filtrar por ciudad de destino</small>
                    </div>
                  </div>
                  <div className="col-md-2 col-sm-6 mb-2">
                    <div className="form-group">
                      <label htmlFor="status_filter" className="col-form-label col-form-label-sm">
                        Estado <span className="list-ticket-required">*</span>
                      </label>
                      <select className="form-control form-control-sm select2" id="status_filter" name="status_filter">
                        <option value="0">Seleccione</option>
                        {status_trip.map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                      <small className="list-ticket-field-hint">Filtrar por estado del boleto</small>
                    </div>
                  </div>
                  <div className="col-md-2 col-sm-6 mb-2">
                    <div className="form-group">
                      <label htmlFor="type_filter" className="col-form-label col-form-label-sm">
                        Tipo <span className="list-ticket-required">*</span>
                      </label>
                      <select className="form-control form-control-sm select2" id="type_filter" name="type_filter">
                        <option value="0">Seleccione</option>
                        {type_filter_search.map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                      <small className="list-ticket-field-hint">Filtrar por tipo de venta</small>
                    </div>
                  </div>

                  
                  <div className="col-md-2 col-sm-6 mb-2">
                      <div className="form-group">
                     <label htmlFor="payment_filter" className="col-form-label col-form-label-sm">
                     Tipo de Pago <span className="list-ticket-required">*</span>
                         </label>
                    <select className="form-control form-control-sm select2" id="payment_filter" name="payment_filter">
                        {payment_filter_options.map((item, index) => (
                       <option key={index} value={item.value}>
                       {item.label}
                            </option>
                                   ))}
                            </select>
                         <small className="list-ticket-field-hint">Filtrar por método de pago</small>
                             </div>
                              </div>


                              
{rol_id !== 3 && (
  <div className="col-md-2 col-sm-6 mb-2">
    <div className="form-group">
      <label htmlFor="user_filter" className="col-form-label col-form-label-sm">
        Usuario <span className="list-ticket-required">*</span>
      </label>
      <select className="form-control form-control-sm select2" id="user_filter" name="user_filter">
        <option value="0">Todos</option>
        {users.map((item, index) => (
          <option key={index} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
      <small className="list-ticket-field-hint">Filtrar por usuario</small>
    </div>
  </div>
)}



  {rol_id === 1 && (
  <div className="col-md-2 col-sm-6 mb-2">
    <div className="form-group">
      <label className="col-form-label col-form-label-sm">
        Días atrás <span className="list-ticket-required">*</span>
      </label>
      <input
        type="number"
        min="0"
        className="form-control form-control-sm"
        value={daysBack}
        onChange={(e) => {
          setDaysBack(Number(e.target.value));
          setStartDateFilter(""); // Limpiar rango al cambiar días atrás
          setEndDateFilter("");
        }}
      />
      <small className="list-ticket-field-hint">
        Configura cuántos días atrás mostrar
      </small>
    </div>
  </div>
)}



                  <div className="col-md-12 col-sm-6 mb-3 text-end">
                    <button onClick={getAll} type="button" className="btn btn-primary btn-sm me-1">
                      <i className="fa-solid fa-magnifying-glass me-1"></i> Buscar
                    </button>
                    <button onClick={handleClear} type="button" className="btn btn-dark btn-sm">
                      <i className="fa-solid fa-eraser me-1"></i> Limpiar
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div className="indications row">
              <div className="col-md-12 col-sm-12 mb-2 text-center">
                <div className="form-group">
                  <table className="table">
                    <thead>
                      <tr>
                        <td className="indications-table" width="20%">
                          Total
                        </td>
                        <td className="indications-table" width="20%">
                          Comprados
                        </td>
                        <td className="indications-table" width="20%">
                          Reservado
                        </td>
                        <td className="indications-table" width="20%">
                          Cancelados
                        </td>
                        <td className="indications-table" width="20%">
                          Pendiente Pago
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td id="TicketTotal">{buys + reserved + canceled}</td>
                        <td id="TicketBuys">{buys}</td>
                        <td id="TicketReserved">{reserved}</td>
                        <td id="TicketCanceled">{canceled}</td>
                        <td id="TicketPending">{pending}</td>
                      </tr>
                    </tbody>
                  </table>
                  </div> 
                

                  {rol_id === 1 && (
  <div className="row mt-3">
    <div className="col-md-12">
      <div className="card border-0 shadow-sm">
        <div className="card-header bg-header-modal py-2">
          <h6 className="mb-0 d-flex align-items-center">
            <i className="fa-solid fa-calculator me-2"></i>
            Resumen de Ventas - Filtrado
          </h6>
        </div>
        <div className="card-body p-3">
          <div className="row">
            <div className="col-md-3 text-center">
              <div className="info-group p-2" style={{ background: "#fff", borderRadius: "8px" }}>
                <small className="text-muted d-block">Total Boletos</small>
                <h4 className="mb-0 text-primary">
                  {tickets.length.toLocaleString('es-MX')}
                </h4>
              </div>
            </div>
            <div className="col-md-3 text-center">
              <div className="info-group p-2" style={{ background: "#fff", borderRadius: "8px" }}>
                <small className="text-muted d-block">Suma Precio Base</small>
                <h4 className="mb-0 text-success">
                  {tickets.reduce((sum, ticket) => sum + parseFloat(ticket.price_ticket || 0), 0).toLocaleString('es-MX', {
                    style: 'currency',
                    currency: 'MXN',
                    minimumFractionDigits: 2
                  })}
                </h4>
              </div>
            </div>
            <div className="col-md-3 text-center">
              <div className="info-group p-2" style={{ background: "#fff", borderRadius: "8px" }}>
                <small className="text-muted d-block">Suma Extras</small>
                <h4 className="mb-0 text-warning">
                  {tickets.reduce((sum, ticket) => sum + parseFloat(ticket.extras.price_extra || 0) + parseFloat(ticket.extras.price_pet || 0), 0).toLocaleString('es-MX', {
                    style: 'currency',
                    currency: 'MXN',
                    minimumFractionDigits: 2
                  })}
                </h4>
              </div>
            </div>
            <div className="col-md-3 text-center">
              <div className="info-group p-2" style={{ 
                background: "linear-gradient(135deg, #033c73 0%, #0056b3 100%)", 
                borderRadius: "8px",
                color: "white"
              }}>
                <small className="text-white-50 d-block">Suma Total</small>
                <h4 className="mb-0 text-white">
                  {sumUser13.toLocaleString('es-MX', {
                    style: 'currency',
                    currency: 'MXN',
                    minimumFractionDigits: 2
                  })}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)}


</div>
</div>

{rol_id === 1 && editRequests.length > 0 && (
  <div className="card border-info mb-3">
    <div className="card-header bg-info d-flex justify-content-between align-items-center">
      <strong>
        <i className="fa-solid fa-pen-to-square me-2"></i>
        Solicitudes de edición pendientes ({editRequests.length})
      </strong>
      <button type="button" className="btn btn-sm btn-dark" onClick={getEditRequests}>
        <i className="fa-solid fa-arrows-rotate"></i>
      </button>
    </div>
    <div className="table-responsive">
      <table className="table table-sm table-hover mb-0">
        <thead>
          <tr>
            <th>Folio</th>
            <th>Pasajero</th>
            <th>Solicitó</th>
            <th>Campos solicitados</th>
            <th className="text-center">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {editRequests.map((editRequest) => (
            <tr key={editRequest.edit_request_id}>
              <td><kbd>#{editRequest.invoice}</kbd></td>
              <td>{editRequest.name} {editRequest.last_name}</td>
              <td>{editRequest.requested_by_name} {editRequest.requested_by_last_name}</td>
              <td>{getEditRequestSummary(editRequest)}</td>
              <td className="text-center">
                <button
                  type="button"
                  className="btn btn-sm btn-success me-1"
                  title="Aprobar edición"
                  onClick={() => reviewEditRequest(editRequest.edit_request_id, "approve")}
                >
                  <i className="fa-solid fa-check"></i>
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  title="Rechazar edición"
                  onClick={() => reviewEditRequest(editRequest.edit_request_id, "reject")}
                >
                  <i className="fa-solid fa-xmark"></i>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)}

{rol_id === 1 && transferRequests.length > 0 && (
  <div className="card border-warning mb-3">
    <div className="card-header bg-warning d-flex justify-content-between align-items-center">
      <strong>
        <i className="fa-solid fa-clock me-2"></i>
        Solicitudes de transferencia pendientes ({transferRequests.length})
      </strong>
      <button type="button" className="btn btn-sm btn-dark" onClick={getTransferRequests}>
        <i className="fa-solid fa-arrows-rotate"></i>
      </button>
    </div>
    <div className="table-responsive">
      <table className="table table-sm table-hover mb-0">
        <thead>
          <tr>
            <th>Folio</th>
            <th>Pasajero</th>
            <th>Solicitó</th>
            <th>Transferencia solicitada</th>
            <th className="text-center">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {transferRequests.map((transferRequest) => (
            <tr key={transferRequest.transfer_request_id}>
              <td><kbd>#{transferRequest.invoice}</kbd></td>
              <td>{transferRequest.name} {transferRequest.last_name}</td>
              <td>{transferRequest.requested_by_name} {transferRequest.requested_by_last_name}</td>
              <td>
                {transferRequest.new_date_ticket} {transferRequest.new_time_ticket}
                <br />Asiento: {transferRequest.new_seat}
              </td>
              <td className="text-center">
                <button
                  type="button"
                  className="btn btn-sm btn-success me-1"
                  title="Aprobar transferencia"
                  onClick={() => reviewTransferRequest(transferRequest.transfer_request_id, "approve")}
                >
                  <i className="fa-solid fa-check"></i>
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  title="Rechazar transferencia"
                  onClick={() => reviewTransferRequest(transferRequest.transfer_request_id, "reject")}
                >
                  <i className="fa-solid fa-xmark"></i>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)}

            <table className="table table-hover main table-striped table-responsive">
  <thead>
    <tr>
      <th className="text-center">Folio</th>
      <th className="text-left">Origen</th>
      <th className="text-left">Destino</th>
      <th className="text-left">Pasajero</th>
      <th className="text-center">Fecha/Hora</th>
      <th className="text-center">Asiento</th>
      <th className="text-center">Precio</th>
      <th className="text-center">
        Precio <br />
        Extra
      </th>
      <th className="text-center">
        Precio <br />
        Mascota
      </th>
      <th className="text-center">Total</th>
      <th className="text-center">Estado</th>
      <th className="text-center">Tipo</th>
      <th className="text-center">Pago</th> 
      <th className="text-center">Opciones</th>
    </tr>
  </thead>
  <tbody>
    {tickets.map((item, index) => {
    const { minutesDifference = 0, timeDifference = 0 } = ticketTimers[item.ticket_id] || {};
    const hideButtons = rol_id === 3 && minutesDifference <= 20 && item.status !== 3

      return (
        <tr key={index}>
          <td className="text-center">
            <kbd># {item.invoice}</kbd>
          </td>
          <td>{item.origin.name}</td>
          <td>{item.destination.name}</td>
          <td>
            {item.name} {item.last_name}
          </td>
          <td className="text-center">
            {item.date_ticket} <br /> {formatTime(item.time_ticket)}
          </td>
          <td className="text-center">{item.seat}</td>
          <td className="text-center">{item.price_ticket}</td>
          <td className="text-center">{item.extras.price_extra}</td>
          <td className="text-center">{item.extras.price_pet}</td>
          <td className="text-center">{item.total_amount}</td>
          <td className="text-center">
            <span
              className={`${
                item.status === 1
                  ? "status-label-deliver"
                  : item.status === 2
                    ? "status-label-destination"
                    : item.status === 3
                      ? "status-label-canceled"
                      : item.status === 4
                        ? "status-label-pending"
                        : ""
              } p-1 rounded w-100 text-center`}
            >
              {item.status === 1
                ? "Comprado"
                : item.status === 2
                  ? "Reservado"
                  : item.status === 3
                    ? "Cancelado"
                    : item.status === 4
                      ? "Pendiente"
                      : ""}
            </span>
          </td>
          <td className="text-center">
            <span
              className={`${
                item.type === 1 ? "type-filter-office" : item.type === 2 ? "type-filter-online" : ""
              } p-1 rounded w-100 text-center`}
            >
              {item.type === 1 ? "Taquilla" : item.type === 2 ? "En Línea" : ""}
            </span>
          </td>

          <td className="text-center">
              <span
             className={`${
            item.card_payment === 1 
               ? "status-label-payment-card" 
               : item.card_payment_transfer === 1 
                 ? "status-label-payment-transfer" 
                : "status-label-payment-cash"
               } p-1 rounded w-100 text-center`}
              >
              {item.card_payment === 1 
               ? "Tarjeta" 
             : item.card_payment_transfer === 1 
                ? "Transferencia" 
                 : "Efectivo"}
                </span>
                </td>


          {/* ... otras celdas ... */}
          <td className="text-center">
            <div>
              {/* Botón Ver - siempre visible */}
              <span data-bs-placement="top" title="Detalle del boleto" data-toggle="tooltip">
                <button
                  data-bs-toggle="modal"
                  data-bs-target="#modal-detail"
                  style={{ marginRight: "2px" }}
                  className="btn-sm btn btn-primary"
                  onClick={() => handleDetail(item.ticket_id)}
                >
                  <i className="fas fa-eye"></i>
                </button>
              </span>

              {/* Solo mostrar los demás botones si el estado NO es cancelado (status !== 3) */}
              {(item.status !== 3 || rol_id === 1) && (
                <>
                  {/* Botón Cambiar estado */}
                  {(rol_id === 1 || (rol_id !== 1 && minutesDifference > 20 && item.status === 2)) && (
                    <span data-bs-placement="top" data-bs-toggle="tooltip" title="Cambiar estatus del boleto">
                      <button
                        data-bs-toggle="modal"
                        data-bs-target="#modal-status"
                        style={{ marginRight: "2px" }}
                        className="btn-sm btn btn-success"
                        onClick={() => handleChangeStatus(item.ticket_id)}
                      >
                        <i className="fa-solid fa-rotate"></i>
                      </button>
                    </span>
                  )}

                  {/* Botón Editar */}
                  {(rol_id === 1 || rol_id === 3) && (
                    <span data-bs-placement="top" title={rol_id === 3 ? "Solicitar edición" : "Editar boleto"} data-bs-toggle="tooltip">
                      <button
                        data-bs-toggle="modal"
                        data-bs-target="#modal-edit"
                        style={{ marginRight: "2px" }}
                        className="btn-sm btn btn-warning"
                        onClick={() => handleEdit(item.ticket_id)}
                      >
                        <i className="fa-solid fa-pen-to-square"></i>
                      </button>
                    </span>
                  )}

                  {/* Botón Agregar Extras */}
                  {rol_id === 1 && (
                    <span data-bs-placement="top" title="Agregar Extras" data-bs-toggle="tooltip">
                      <button
                        data-bs-toggle="modal"
                        data-bs-target="#modal-extras"
                        style={{ marginRight: "2px" }}
                        className="btn-sm btn btn-secondary"
                        onClick={() => handleExtras(item.ticket_id)}
                      >
                        <i className="fa-solid fa-circle-plus"></i>
                      </button>
                    </span>
                  )}

                  {/* Botón Cancelar - solo para roles 1 */}
                  {rol_id === 1 && (
                    <span data-bs-placement="top" title="Cancelar boleto" data-bs-toggle="tooltip">
                      <button
                        data-toggle="tooltip"
                        style={{ marginRight: "2px" }}
                        className="btn-sm btn btn-danger"
                        onClick={() => handleCancel(item.ticket_id, item.invoice)}
                      >
                        <i className="fa-solid fa-ban"></i>
                      </button>
                    </span>
                  )}

                  {/* Botón Imprimir */}
                  <span
                    data-bs-placement="top"
                    title="Reimprimir boleto"
                    data-bs-toggle="tooltip"
                    style={{ marginRight: "2px" }}
                  >
                    <button
                      data-bs-toggle="tooltip"
                      style={{ marginRight: "2px" }}
                      className="btn-sm btn btn-dark"
                      onClick={() => handlePrint(item.invoice)}
                    >
                      <i className="fa-solid fa-print"></i>
                    </button>
                  </span>

                  {/* Botón WhatsApp */}
<span
  data-bs-placement="top"
  title="Enviar por WhatsApp"
  data-bs-toggle="tooltip"
  style={{ marginRight: "2px" }}
>
  <button
    data-bs-toggle="tooltip"
    style={{ marginRight: "2px" }}
    className="btn-sm btn btn-success"
    onClick={() => handleWhatsApp(item.invoice, item.name, item.last_name, item.phone)}
  >
    <i className="fa-brands fa-whatsapp"></i>
  </button>
</span>

                  {/* Botón Reenviar por correo */}
                  {(rol_id === 1 || rol_id === 2 || rol_id === 10 || !hideButtons) && (
                    <span
                      data-bs-placement="top"
                      title="Reenviar boleto por correo"
                      data-bs-toggle="tooltip"
                      style={{ marginRight: "2px" }}
                    >
                      <button
                        data-bs-toggle="tooltip"
                        style={{ marginRight: "2px" }}
                        className="btn-sm btn btn-info"
                        onClick={() => handleEmail(item.ticket_id)}
                      >
                        <i className="fa-solid fa-envelope"></i>
                      </button>
                    </span>
                  )}

                  {/* Solicitud de transferencia para rol 3 */}
                  {rol_id === 3 && minutesDifference > 30 && timeDifference > 0 && (
                    <span data-bs-placement="top" title="Solicitar transferencia" data-bs-toggle="tooltip">
                      <button
                        data-bs-toggle="modal"
                        data-bs-target="#modal-transfer"
                        style={{ marginRight: "2px" }}
                        className="btn-sm btn btn-warning"
                        onClick={() => handleTransfer(item.ticket_id)}
                      >
                        <i className="fa-solid fa-file-circle-plus"></i>
                      </button>
                    </span>
                  )}

                  {/* Botón Transferir */}
                  {(rol_id === 1 || rol_id === 2 || rol_id === 10 || ((minutesDifference > 30 && timeDifference > 0) && rol_id !== 3)) && (
                    <span data-bs-placement="top" title="Transferir boleto" data-bs-toggle="tooltip">
                      <button
                        data-bs-toggle="modal"
                        data-bs-target="#modal-transfer"
                        style={{ marginRight: "2px" }}
                        className="btn-sm btn btn-info"
                        onClick={() => handleTransfer(item.ticket_id)}
                      >
                        <i className="fa-solid fa-exchange-alt"></i>
                      </button>
                    </span>
                  )}
                </>
              )}
            </div>
          </td>
        </tr>
      )
    })}
  </tbody>
</table>
          </div>
        </div>
      </div>

      {/* Modal de Transferencia */}
      <div className="modal fade" id="modal-transfer" aria-labelledby="modal-transfer" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <div className="modal-header bg-header-modal py-2">
              <h5 className="modal-title fs-6 d-flex align-items-center mb-0">
                <i className="fa-solid fa-exchange-alt me-2"></i>
                {transferRequiresApproval ? "Solicitar transferencia" : "Transferir Boleto"} #{transferInvoice}
              </h5>
              <button type="button" className="btn-close btn-sm" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <form onSubmit={handleTransferSubmit}>
              <div className="modal-body p-3">
                <div className="row">
                  {/* Left Column - Passenger Info */}
                  <div className="col-md-4">
                    {/* Ticket Info Card */}
                    <div className="card mb-4 border-0 shadow-sm">
                      <div
                        className="card-body p-3"
                        style={{
                          background: "linear-gradient(135deg, #033c73 0%, #0056b3 100%)",
                          borderRadius: "10px",
                          color: "white",
                        }}
                      >
                        <h6 className="card-title d-flex align-items-center mb-3">
                          <i className="fa-solid fa-ticket-alt me-2"></i>
                          Información del Boleto Original
                        </h6>
                        <div className="info-group mb-3">
                          <small className="d-block text-white-50">Pasajero</small>
                          <p className="mb-0 fw-bold">
                            {name} {last_name}
                          </p>
                        </div>
                        <div className="row g-2">
                          <div className="col-6">
                            <small className="d-block text-white-50">Origen</small>
                            <p className="mb-0 fw-bold">
                              {transferOrigin || origins.find((o) => o.value === origin_id)?.label || ""}
                            </p>
                          </div>
                          <div className="col-6">
                            <small className="d-block text-white-50">Destino</small>
                            <p className="mb-0 fw-bold">
                              {transferDestination || destinations.find((d) => d.value === destination_id)?.label || ""}
                            </p>
                          </div>
                        </div>
                        <div className="row g-2 mt-2">
                          <div className="col-6">
                            <small className="d-block text-white-50">Asiento</small>
                            <p className="mb-0 fw-bold">{seat}</p>
                          </div>
                          <div className="col-6">
                            <small className="d-block text-white-50">Fecha/Horario</small>
                            <p className="mb-0 fw-bold">
                              {date_ticket} {formatTime(time_ticket)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Transfer Options Card */}
                    <div className="card border-0 shadow-sm mb-4">
                      <div className="card-body p-3" style={{ background: "#f8f9fa", borderRadius: "8px" }}>
                        <h6
                          className="card-title d-flex align-items-center mb-3"
                          style={{ fontSize: "0.9rem", color: "#033c73" }}
                        >
                          <i className="fa-solid fa-calendar-alt me-2"></i>
                          Opciones de Transferencia
                        </h6>

                        <form>
                          <div className="row g-2">
                            {/* Base */}
                            <div className="col-md-6 mb-2">
                              <label htmlFor="branch_id" className="form-label small mb-1">
                                Base <span className="text-danger">*</span>
                              </label>
                              <select id="branch_id" name="branch_id" className="form-select form-select-sm" required>
                                <option value="">Seleccione base</option>
                                {branchs.map((item, index) => (
                                  <option key={index} value={item.value}>
                                    {item.label}
                                  </option>
                                ))}
                              </select>
                              <small className="text-muted" style={{ fontSize: "0.75rem" }}>
                                Seleccione la base de operación
                              </small>
                            </div>

                            {/* Origen */}
                            <div className="col-md-6 mb-2">
                              <label htmlFor="origin_id" className="form-label small mb-1">
                                Origen <span className="text-danger">*</span>
                              </label>
                              <select id="origin_ida" name="origin_id" className="form-select form-select-sm" required>
                                <option value="">Seleccione origen</option>
                                {origins.map((item, index) => (
                                  <option key={index} value={item.value}>
                                    {item.label}
                                  </option>
                                ))}
                              </select>
                              <small className="text-muted" style={{ fontSize: "0.75rem" }}>
                                Seleccione el nuevo origen del viaje
                              </small>
                            </div>

                            {/* Destino */}
                            <div className="col-md-6 mb-2">
                              <label htmlFor="destination_id" className="form-label small mb-1">
                                Destino <span className="text-danger">*</span>
                              </label>
                              <select
                                id="destination_ida"
                                name="destination_id"
                                className="form-select form-select-sm"
                                required
                              >
                                <option value="">Seleccione destino</option>
                                {destinations.map((item, index) => (
                                  <option key={index} value={item.value}>
                                    {item.label}
                                  </option>
                                ))}
                              </select>
                              <small className="text-muted" style={{ fontSize: "0.75rem" }}>
                                Seleccione el nuevo destino del viaje
                              </small>
                            </div>

                            {/* Fecha */}
                            <div className="col-md-6 mb-2">
                              <label htmlFor="date" className="form-label small mb-1">
                                Fecha <span className="text-danger">*</span>
                              </label>
                              <DatePicker
                                showIcon
                                locale="es"
                                selected={date}
                                onChange={(date) => setDate(date)}
                                minDate={new Date()}
                                className="form-control form-control-sm"
                                dateFormat="dd/MM/yyyy"
                              />
                              <small className="text-muted" style={{ fontSize: "0.75rem" }}>
                                Seleccione la nueva fecha del viaje
                              </small>
                            </div>

                            {/* Botón */}
                            <div className="col-md-12 mt-1">
                              <button onClick={handleSearch} className="btn btn-primary btn-sm">
                                <i className="fa-solid fa-magnifying-glass me-1"></i> Buscar
                              </button>
                            </div>
                            {filtradoBuscar && (
                              <div className="col-md-12 mt-3">
                                <label htmlFor="schedule_select" className="form-label small mb-1">
                                  Horario <span className="text-danger">*</span>
                                </label>
                                <select
                                  id="schedule_select"
                                  className="form-select form-select-sm"
                                  required
                                  onChange={(e) => {
                                    const scheduleId = Number.parseInt(e.target.value)
                                    setSelectedScheduleId(scheduleId)
                                    if (scheduleId) {
                                      setSelecionarHorario(true)
                                      getAvailableSeats(scheduleId, formatDateForAPI(date))
                                    } else {
                                      setSelecionarHorario(false)
                                    }
                                  }}
                                >
                                  <option value="">Seleccione horario</option>
                                  {schedulesDisponibles.map((item, index) => (
                                    <option key={index} value={item.schedule_id}>
                                      {item.time}
                                    </option>
                                  ))}
                                </select>
                                <small className="text-muted" style={{ fontSize: "0.75rem" }}>
                                  Seleccione el horario para ver asientos disponibles
                                </small>
                              </div>
                            )}
                          </div>
                        </form>
                      </div>
                    </div>

                    {/* Instructions Card */}
                    <div className="card border-0 shadow-sm">
                      <div className="card-body p-3" style={{ background: "#fff8e1", borderRadius: "8px" }}>
                        <h6
                          className="card-title d-flex align-items-center mb-2"
                          style={{ fontSize: "0.9rem", color: "#ff8f00" }}
                        >
                          <i className="fa-solid fa-info-circle me-2"></i>
                          Instrucciones
                        </h6>
                        <ol className="mb-0 ps-3" style={{ fontSize: "0.85rem" }}>
                          <li className="mb-1">Seleccione la fecha para la transferencia.</li>
                          <li className="mb-1">Elija el horario disponible.</li>
                          <li className="mb-1">Seleccione un asiento disponible en el diagrama.</li>
                          <li className="mb-1">Haga clic en "Transferir Boleto" para confirmar.</li>
                        </ol>
                      </div>
                    </div>
                  </div>

                  {/* Right Column - Seat Selection */}
                  {selecionarHorario ? (
                    <div className="col-md-8">
                      <div className="card border-0 shadow-sm">
                        <div className="card-body p-3" style={{ background: "#f8f9fa", borderRadius: "8px" }}>
                          <h6
                            className="card-title d-flex align-items-center mb-3"
                            style={{ fontSize: "0.9rem", color: "#033c73" }}
                          >
                            <i className="fa-solid fa-chair me-2"></i>
                            Selección de Asiento
                          </h6>

                          <div className="seat-selection-container">
                            {/* Seat Legend */}
                            <div className="seat-legend">
                              <div className="legend-item">
                                <div className="seat-sample available me-2"></div>
                                <span style={{ fontSize: "0.8rem" }}>Disponible</span>
                              </div>
                              <div className="legend-item">
                                <div className="seat-sample selected me-2"></div>
                                <span style={{ fontSize: "0.8rem" }}>Seleccionado</span>
                              </div>
                              <div className="legend-item">
                                <div className="seat-sample occupied me-2"></div>
                                <span style={{ fontSize: "0.8rem" }}>Ocupado</span>
                              </div>
                              <div className="legend-item">
                                <div className="seat-sample reserved me-2"></div>
                                <span style={{ fontSize: "0.8rem" }}>Reservado</span>
                              </div>
                            </div>

                            {/* Bus Layout */}
                            <div className="bus-layout-container">
                              <div className="driver-seat mb-3 text-center">
                                <i
                                  className="fa-solid fa-steering-wheel"
                                  style={{ fontSize: "1.5rem", color: "#033c73" }}
                                ></i>
                              </div>

                              {busCapacity  && (
                                <div className="bus-layout-11">
                                  {Object.values(busLayout).map((row, rowIndex) => (
                                    <div key={rowIndex} className="d-flex justify-content-center gap-2 mb-2">
                                      <div className="d-flex gap-2">
                                        {row.slice(0, 2).map((seat, idx) => (
                                          <React.Fragment key={`left-${idx}`}>{renderSeat(seat)}</React.Fragment>
                                        ))}
                                      </div>
                                      <div className="seat-space gap-2" /> {/* Aisle */}
                                      <div className="d-flex gap-2">
                                        {row.slice(2).map((seat, idx) => (
                                          <React.Fragment key={`right-${idx}`}>{renderSeat(seat)}</React.Fragment>
                                        ))}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}

                              {!busCapacity && (
                                <div className="text-center p-5">
                                  <i className="fa-solid fa-bus text-muted mb-3" style={{ fontSize: "3rem" }}></i>
                                  <p className="mb-0">Cargando asientos disponibles...</p>
                                </div>
                              )}
                            </div>

                            {/* Selected Seat Info */}
                            {selectedSeat > 0 && (
                              <div
                                className="selected-seat-info mt-4 p-3"
                                style={{ background: "#e3f2fd", borderRadius: "8px" }}
                              >
                                <div className="d-flex justify-content-between align-items-center">
                                  <div>
                                    <h6 className="mb-1" style={{ color: "#0d47a1" }}>
                                      Asiento Seleccionado: <span className="fw-bold">{selectedSeat}</span>
                                    </h6>
                                    <p className="mb-0 small text-muted">
                                      {transferOrigin || origins.find((o) => o.value === origin_id)?.label || ""} →{" "}
                                      {transferDestination ||
                                        destinations.find((d) => d.value === destination_id)?.label ||
                                        ""}
                                    </p>
                                  </div>
                                  <button
                                    type="button"
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() => setSelectedSeat(0)}
                                  >
                                    <i className="fa-solid fa-times me-1"></i>
                                    Cambiar
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="col-md-8">
                      <div className="card border-0 shadow-sm">
                        <div className="card-body p-3" style={{ background: "#f8f9fa", borderRadius: "8px" }}>
                          <div className="text-center p-5">
                            <svg
                              width="200"
                              height="150"
                              viewBox="0 0 200 150"
                              xmlns="http://www.w3.org/2000/svg"
                              className="mb-3"
                            >
                              <rect width="200" height="150" fill="#f0f0f0" rx="10" />
                              <circle cx="100" cy="50" r="30" fill="#e0e0e0" />
                              <path d="M85 50 L115 50 M100 35 L100 65" stroke="#a0a0a0" strokeWidth="4" />
                              <path d="M70 90 C70 70, 130 70, 130 90" stroke="#a0a0a0" strokeWidth="2" fill="none" />
                              <text x="100" y="110" fontFamily="Arial" fontSize="12" textAnchor="middle" fill="#666">
                                Seleccione un horario
                              </text>
                            </svg>
                            <h5 className="text-muted">Falta seleccionar horario</h5>
                            <p className="text-muted">
                              Por favor, seleccione un horario para ver los asientos disponibles.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer py-2">
                <button type="submit" className="btn btn-success btn-sm" disabled={!selectedSeat}>
                  <i className="fa-solid fa-exchange-alt me-1"></i>
                  {transferRequiresApproval ? "Enviar solicitud" : "Transferir Boleto"}
                </button>
                <button
                  id="closemodal-transfer"
                  type="button"
                  className="btn btn-danger btn-sm"
                  data-bs-dismiss="modal"
                >
                  <i className="fa-solid fa-xmark me-1"></i>
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ListTickets
